webpackJsonp([4],{

/***/ 111:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8eb946eca268db43b3c44d8af958d66d.png";

/***/ }),

/***/ 135:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(545);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(35)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./StatusPageWidget.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./StatusPageWidget.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 136:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SystemNotificationFlags; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SystemNotificationDeliveryMethod; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SystemNotificationApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ApiBase__ = __webpack_require__(137);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var SystemNotificationFlags;
(function (SystemNotificationFlags) {
    /** can't be marked as read by the user */
    SystemNotificationFlags[SystemNotificationFlags["NOT_READABLE"] = 1] = "NOT_READABLE";
})(SystemNotificationFlags || (SystemNotificationFlags = {}));
var SystemNotificationDeliveryMethod;
(function (SystemNotificationDeliveryMethod) {
    /**
     * deliver using push
     */
    SystemNotificationDeliveryMethod[SystemNotificationDeliveryMethod["PUSH"] = 1] = "PUSH";
    /**
     * deliver using mail, will happen immediately & always (unlike {@link OPTIONAL_MAIL})
     */
    SystemNotificationDeliveryMethod[SystemNotificationDeliveryMethod["MAIL"] = 2] = "MAIL";
    /**
     * deliver using email, but only if the notification wasn't read otherwise
     * the mail will send depending a user options. for example once a day.
     */
    SystemNotificationDeliveryMethod[SystemNotificationDeliveryMethod["OPTIONAL_MAIL"] = 4] = "OPTIONAL_MAIL";
    /**
     * shortcut, push to web app and send optional mail.
     * Should be the default for most cases
     */
    SystemNotificationDeliveryMethod[SystemNotificationDeliveryMethod["PUSH_OPTIONAL_MAIL"] = 0] = "PUSH_OPTIONAL_MAIL";
})(SystemNotificationDeliveryMethod || (SystemNotificationDeliveryMethod = {}));
var SystemNotificationApi = /** @class */ (function (_super) {
    __extends(SystemNotificationApi, _super);
    function SystemNotificationApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SystemNotificationApi.prototype.getMyUnread = function () {
        return this.client.callCfc("SystemNotification.getMyUnread", {});
    };
    SystemNotificationApi.prototype.get = function (query) {
        return this.client.callCfc("SystemNotification.get", {});
    };
    SystemNotificationApi.prototype.markAsRead = function (id) {
        return this.client.callCfc("SystemNotification.markAsRead", {});
    };
    return SystemNotificationApi;
}(__WEBPACK_IMPORTED_MODULE_0__ApiBase__["a" /* ApiBase */]));



/***/ }),

/***/ 137:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ApiBase; });
var ApiBase = /** @class */ (function () {
    function ApiBase(client) {
        this.client = client;
    }
    return ApiBase;
}());



/***/ }),

/***/ 138:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ApiBase__ = __webpack_require__(137);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ApiClient__ = __webpack_require__(553);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__ApiClient__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ApiError__ = __webpack_require__(327);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SystemImportApi__ = __webpack_require__(328);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SystemNotificationApi__ = __webpack_require__(136);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__SystemNotificationApi__["c"]; });







/***/ }),

/***/ 139:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AppState__ = __webpack_require__(554);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__AppState__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Entity__ = __webpack_require__(329);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PresenceStore__ = __webpack_require__(555);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__PresenceStore__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__PresenceStore__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SystemNotificationStore__ = __webpack_require__(556);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_3__SystemNotificationStore__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__StatusPageStore__ = __webpack_require__(557);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__StatusPageStore__["a"]; });







/***/ }),

/***/ 143:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ActivityIndicator_ActivityIndicator__ = __webpack_require__(403);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "ActivityIndicator", function() { return __WEBPACK_IMPORTED_MODULE_0__ActivityIndicator_ActivityIndicator__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StatusPageWidget_StatusPageWidget__ = __webpack_require__(406);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "StatusPageWidget", function() { return __WEBPACK_IMPORTED_MODULE_1__StatusPageWidget_StatusPageWidget__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NotificationCenter_NotificationCenter__ = __webpack_require__(547);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "NotificationCenter", function() { return __WEBPACK_IMPORTED_MODULE_2__NotificationCenter_NotificationCenter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OnlineList_OnlineList__ = __webpack_require__(592);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "OnlineList", function() { return __WEBPACK_IMPORTED_MODULE_3__OnlineList_OnlineList__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__StatusPageWidget_StatusPageWidgetLogin__ = __webpack_require__(597);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "StatusPageWidgetLogin", function() { return __WEBPACK_IMPORTED_MODULE_4__StatusPageWidget_StatusPageWidgetLogin__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Avatar_Avatar__ = __webpack_require__(347);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Avatar", function() { return __WEBPACK_IMPORTED_MODULE_5__Avatar_Avatar__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "OnlineStatus", function() { return __WEBPACK_IMPORTED_MODULE_5__Avatar_Avatar__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Table_Table__ = __webpack_require__(598);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Table", function() { return __WEBPACK_IMPORTED_MODULE_6__Table_Table__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "TableCell", function() { return __WEBPACK_IMPORTED_MODULE_6__Table_Table__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FpProvider__ = __webpack_require__(601);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "FpProvider", function() { return __WEBPACK_IMPORTED_MODULE_7__FpProvider__["a"]; });










/***/ }),

/***/ 208:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return StatusPageMessageGenerator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StatusPageError; });
/* unused harmony export StatusMessage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StatusPageWidget_scss__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StatusPageWidget_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__StatusPageWidget_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_fontawesome_pro_solid__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fortawesome_fontawesome_pro_light__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fortawesome_fontawesome_pro_light___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__fortawesome_fontawesome_pro_light__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fortawesome_react_fontawesome__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fortawesome_react_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__fortawesome_react_fontawesome__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

//import testData from "./testdata.json";




var StatusPageMessageGenerator = /** @class */ (function () {
    function StatusPageMessageGenerator() {
    }
    StatusPageMessageGenerator.getIncidents = function (status, size, advancedDetails) {
        var ins;
        //	if (status.status.indicator !== "none") {
        if (status.incidents.length > 0) {
            ins = status.incidents.map(function (incident, index) {
                if (!advancedDetails || incident.incident_updates.length === 1) {
                    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { key: incident.id },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](StatusMessage, { messageType: "Incident", messageName: incident.name, messageContent: incident.incident_updates[0].body, messageDateCreated: incident.created_at, fontSize: size }),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { style: { fontSize: size - 2 + "px", color: "grey" }, href: incident.shortlink, target: "_blank" },
                            "Click here to view more details\u00A0",
                            " ",
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__fortawesome_react_fontawesome___default.a, { icon: __WEBPACK_IMPORTED_MODULE_3__fortawesome_fontawesome_pro_light__["faExternalLink"] })),
                        !(index === status.incidents.length - 1) && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("hr", { className: __WEBPACK_IMPORTED_MODULE_1__StatusPageWidget_scss___default.a.hrStatus })));
                }
                else {
                    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { key: incident.id },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](StatusMessage, { messageType: "Incident", messageName: incident.name, messageContent: incident.incident_updates[incident.incident_updates.length - 1].body, messageDateCreated: incident.created_at, fontSize: size }),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("hr", { style: { margin: "5px 0" } }),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](StatusMessage, { messageType: "Newest Update:", messageName: "", messageContent: incident.incident_updates[0].body, messageDateCreated: incident.incident_updates[0].created_at, fontSize: size }),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { style: { fontSize: size - 2 + "px", color: "grey" }, href: incident.shortlink, target: "_blank" },
                            "Click here to view more details\u00A0",
                            " ",
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__fortawesome_react_fontawesome___default.a, { icon: __WEBPACK_IMPORTED_MODULE_3__fortawesome_fontawesome_pro_light__["faExternalLink"] })),
                        incident.incident_updates.length > 1 &&
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, !(index === status.incidents.length - 1) && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("hr", { className: __WEBPACK_IMPORTED_MODULE_1__StatusPageWidget_scss___default.a.hrStatus })),
                        !(index === status.incidents.length - 1) && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("hr", { className: __WEBPACK_IMPORTED_MODULE_1__StatusPageWidget_scss___default.a.hrStatus })));
                }
            });
        }
        else if (status.status.indicator !== "none") {
            ins =
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](StatusMessage, { messageType: "Incident", messageName: "Unknown Incident", messageContent: "We cannot provide any information to this problem right now! We're working on a solution", messageDateCreated: "", fontSize: size }));
        }
        //}
        return ins;
    };
    StatusPageMessageGenerator.getMaintence = function (status, size, advancedDetails) {
        var main;
        main = status.scheduled_maintenances.map(function (maintenance, index) {
            if (!advancedDetails || maintenance.incident_updates.length === 1) {
                return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { key: maintenance.id },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](StatusMessage, { messageType: "Maintenance", messageName: maintenance.name, messageContent: maintenance.incident_updates[0].body, messageDateCreated: maintenance.created_at, messageDateScheduled: maintenance.scheduled_for, fontSize: size, maintenanceStatus: maintenance.status }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { style: { fontSize: size - 2 + "px", color: "grey" }, href: maintenance.shortlink, target: "_blank" },
                        "Click here to view more details\u00A0",
                        " ",
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__fortawesome_react_fontawesome___default.a, { icon: __WEBPACK_IMPORTED_MODULE_3__fortawesome_fontawesome_pro_light__["faExternalLink"] })),
                    !(index === status.scheduled_maintenances.length - 1) && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("hr", { className: __WEBPACK_IMPORTED_MODULE_1__StatusPageWidget_scss___default.a.hrStatus })));
            }
            else {
                return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { key: maintenance.id },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](StatusMessage, { messageType: "Maintenance", messageName: maintenance.name, messageContent: maintenance.incident_updates[maintenance.incident_updates.length - 1].body, messageDateCreated: maintenance.created_at, messageDateScheduled: maintenance.scheduled_for, maintenanceStatus: maintenance.status, fontSize: size }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("hr", { style: { margin: "5px 0" } }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](StatusMessage, { messageType: "Newest Update:", messageName: "", messageContent: maintenance.incident_updates[0].body, messageDateCreated: maintenance.incident_updates[0].created_at, fontSize: size }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { style: { fontSize: size - 2 + "px", color: "grey" }, href: maintenance.shortlink, target: "_blank" },
                        "Click here to view more details\u00A0",
                        " ",
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__fortawesome_react_fontawesome___default.a, { icon: __WEBPACK_IMPORTED_MODULE_3__fortawesome_fontawesome_pro_light__["faExternalLink"] })),
                    maintenance.incident_updates.length > 1 &&
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, !(index === status.scheduled_maintenances.length - 1) && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("hr", { className: __WEBPACK_IMPORTED_MODULE_1__StatusPageWidget_scss___default.a.hrStatus })),
                    !(index === status.scheduled_maintenances.length - 1) && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("hr", { className: __WEBPACK_IMPORTED_MODULE_1__StatusPageWidget_scss___default.a.hrStatus })));
            }
        });
        return main;
    };
    return StatusPageMessageGenerator;
}());

var StatusPageError = /** @class */ (function (_super) {
    __extends(StatusPageError, _super);
    function StatusPageError(props) {
        return _super.call(this, props) || this;
    }
    StatusPageError.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](StatusMessage, { messageName: "StatusPageError", messageContent: "Couldn't get any data from our statuspage. Either you are not connected to the internet, or our statuspage is down!", messageType: "Error while Fetching!", fontSize: 10, messageDateCreated: "" }));
    };
    return StatusPageError;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));

/**
 * This component contains the status messages
 *
 * props:
 * messageType: Incident or mainteance
 * messageName: Title of the message
 * messageContent: the content of the message
 */
var StatusMessage = /** @class */ (function (_super) {
    __extends(StatusMessage, _super);
    function StatusMessage(props) {
        return _super.call(this, props) || this;
    }
    StatusMessage.prototype.replaceNwBr = function () {
        return { __html: this.props.messageContent.replace(/\n/g, "<br>") };
    };
    StatusMessage.prototype.render = function () {
        var timeCreated = new Date(this.props.messageDateCreated);
        var timeScheduled = this.props.messageDateScheduled ? new Date(this.props.messageDateScheduled) : null;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { style: { fontSize: this.props.fontSize + 2 + "px", display: "block", lineHeight: "1.5" } },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { style: { fontSize: this.props.fontSize + "px" } },
                    this.props.messageType,
                    " ",
                    " ",
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { style: { fontSize: this.props.fontSize + "px", color: "grey", fontStyle: "italic" } }, (this.props.messageDateScheduled) &&
                        this.props.maintenanceStatus === "in_progress" ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { style: { color: "steelblue" } },
                        "In progress",
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "fa-stack", style: { fontSize: "7px", bottom: "-4px" } },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__fortawesome_react_fontawesome___default.a, { icon: __WEBPACK_IMPORTED_MODULE_2__fortawesome_fontawesome_pro_solid__["j" /* faWrench */], className: "fa-stack-2x", style: { fontSize: "4px" } }),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "fa-stack-2x " + __WEBPACK_IMPORTED_MODULE_1__StatusPageWidget_scss___default.a.spinner })))
                        :
                            (timeScheduled &&
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null,
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { style: { fontSize: this.props.fontSize - 2 + "px", color: "grey" } },
                                        "scheduled for ",
                                        " ", " " + timeScheduled.toDateString() + " - " + timeScheduled.getHours() + ":" + timeScheduled.getMinutes() + (timeScheduled.getMinutes() < 10 ? "0" : ""))))))),
            this.props.messageName,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { dangerouslySetInnerHTML: this.replaceNwBr(), className: __WEBPACK_IMPORTED_MODULE_1__StatusPageWidget_scss___default.a.statusWidgetText, style: { fontSize: this.props.fontSize + "px" } }),
            (this.props.messageDateCreated) &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { style: { fontSize: this.props.fontSize - 2 + "px", color: "grey" } },
                    "Message was created at:", " " + timeCreated.toDateString() + " - " + timeCreated.getHours() + ":" + timeCreated.getMinutes() + (timeCreated.getMinutes() < 10 ? "0" : ""))));
    };
    return StatusMessage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));



/***/ }),

/***/ 327:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ApiError; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * Represents an Error Object that is returned by the API Server.
 */
var ApiError = /** @class */ (function (_super) {
    __extends(ApiError, _super);
    function ApiError(code, message, data) {
        return _super.call(this, message) || this;
    }
    return ApiError;
}(Error));



/***/ }),

/***/ 328:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SystemImportApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ApiBase__ = __webpack_require__(137);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var SystemImportApi = /** @class */ (function (_super) {
    __extends(SystemImportApi, _super);
    function SystemImportApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SystemImportApi.prototype.uploadTempFile = function () {
        return this.client.callCfc("SystemImport.uploadTempFile", {});
    };
    SystemImportApi.prototype.newJobFromUpload = function (uploadTaskId, targetType) {
        return this.client.callCfc("SystemImport.newJobFromUpload", { uploadTaskId: uploadTaskId, targetType: targetType });
    };
    SystemImportApi.prototype.previewMappingForValues = function (targetType, targetField, mapping, rows) {
        return this.client.callCfc("SystemImport.previewMappingForValues", { targetType: targetType, targetField: targetField, mapping: mapping, rows: rows });
    };
    SystemImportApi.prototype.runImport = function (jobId, sourceId, mapping) {
        return this.client.callCfc("SystemImport.runImport", { jobId: jobId, sourceId: sourceId, mapping: mapping });
    };
    SystemImportApi.prototype.exportFailedRows = function (jobId, sourceId) {
        return this.client.callCfc("SystemImport.exportFailedRows", { jobId: jobId, sourceId: sourceId });
    };
    return SystemImportApi;
}(__WEBPACK_IMPORTED_MODULE_0__ApiBase__["a" /* ApiBase */]));



/***/ }),

/***/ 329:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Entity; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);

var Entity = /** @class */ (function () {
    function Entity() {
    }
    Entity.prototype.assign = function (data) {
        if (data === void 0) { data = {}; }
        __WEBPACK_IMPORTED_MODULE_0_lodash__["assign"](this, data);
        return this;
    };
    return Entity;
}());



/***/ }),

/***/ 330:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TIME_LENGTH */
/* unused harmony export TIME_MAX */
/* unused harmony export SEED_LENGTH */
/* unused harmony export SEED_MAX */
/* unused harmony export INCR_LENGTH */
/* unused harmony export INCR_MAX */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FpId; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);

var TIME_LENGTH = 10;
var TIME_MAX = parseInt(__WEBPACK_IMPORTED_MODULE_0_lodash__["repeat"]("z", TIME_LENGTH), 36); // 3.656.158.440.062.975 // 11. Jan 117.829
var SEED_LENGTH = 10;
var SEED_MAX = parseInt(__WEBPACK_IMPORTED_MODULE_0_lodash__["repeat"]("z", SEED_LENGTH), 36); // 3.656.158.440.062.975
var INCR_LENGTH = 2;
var INCR_MAX = parseInt(__WEBPACK_IMPORTED_MODULE_0_lodash__["repeat"]("z", INCR_LENGTH), 36); // 1.295
var FpId = /** @class */ (function () {
    function FpId() {
    }
    Object.defineProperty(FpId, "seed", {
        get: function () { return this._seed; },
        set: function (value) {
            if (value < 0 || value > SEED_MAX) {
                throw new Error("value must be between 0 and " + SEED_MAX + " (inclusive)");
            }
            this._seed = value;
        },
        enumerable: true,
        configurable: true
    });
    FpId.new = function () {
        if (FpId.seed == null) {
            throw new Error("seed is not set, it must be set before generating new IDs");
        }
        if (FpId.incr > INCR_MAX) {
            FpId.incr = 0;
        }
        var time = (+new Date()).toString(36);
        var seed = (FpId.seed).toString(36);
        var incr = (FpId.incr++).toString(36);
        return __WEBPACK_IMPORTED_MODULE_0_lodash__["padStart"](time, TIME_LENGTH, "0")
            + "_" + __WEBPACK_IMPORTED_MODULE_0_lodash__["padStart"](seed, SEED_LENGTH, "0")
            + "_" + __WEBPACK_IMPORTED_MODULE_0_lodash__["padStart"](incr, INCR_LENGTH, "0");
    };
    FpId.incr = Math.floor(Math.random() * INCR_MAX);
    FpId._seed = 0; // TODO:
    return FpId;
}());



/***/ }),

/***/ 331:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {/* unused harmony export MqttState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MqttClient; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mqtt__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mqtt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mqtt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_autobind_decorator__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_autobind_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_autobind_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FpId__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stores__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_timers__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_timers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_timers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mobx__ = __webpack_require__(33);
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};






var MqttState;
(function (MqttState) {
    MqttState[MqttState["CONNECTING"] = 0] = "CONNECTING";
    MqttState[MqttState["ONLINE"] = 1] = "ONLINE";
    MqttState[MqttState["OFFLINE"] = 2] = "OFFLINE";
})(MqttState || (MqttState = {}));
var MqttClient = /** @class */ (function () {
    function MqttClient(appState, presenceStore) {
        this.appState = appState;
        this.presenceStore = presenceStore;
        this.state = MqttState.OFFLINE;
    }
    MqttClient.prototype.connect = function () {
        var _this = this;
        if (this.client) {
            this.end();
        }
        this.state = MqttState.CONNECTING;
        this.client = __WEBPACK_IMPORTED_MODULE_0_mqtt__["connect"]("wss://" + window.location.host + "/mqtt", {
            keepalive: 30,
            clientId: __WEBPACK_IMPORTED_MODULE_2__FpId__["a" /* FpId */].new(),
            clean: false,
            // set the presence offline as our last will
            will: {
                topic: "dscid/" + this.appState.dscid + "/presence/dscaid/" + this.appState.dscaid,
                payload: JSON.stringify({
                    apiVersion: "presence/v1",
                    type: "setPresence",
                    data: {
                        presence: __WEBPACK_IMPORTED_MODULE_3__stores__["b" /* PresenceState */].OFFLINE,
                        note: ""
                    },
                }),
                qos: 0,
                retain: false,
            }
        });
        this.client.subscribe("dscid/" + this.appState.dscid + "/presence/state");
        this.client.subscribe("dscid/" + this.appState.dscid + "/presence/event");
        this.client.on("connect", function () { return _this.state = MqttState.ONLINE; });
        this.client.on("offline", function () { return _this.state = MqttState.OFFLINE; });
        this.client.on("close", function () { return _this.state = MqttState.OFFLINE; });
        this.client.on("message", this.handleMessage);
        // ping server every 30 seconds with our presence
        this.sendPresence();
        Object(__WEBPACK_IMPORTED_MODULE_4_timers__["setInterval"])(this.sendPresence, 30 * 1000);
        // ... or if our note changes
        Object(__WEBPACK_IMPORTED_MODULE_5_mobx__["j" /* reaction */])(function () { return _this.presenceStore.myNote; }, function () { return _this.sendPresence(); }, { delay: 3000 });
    };
    MqttClient.prototype.end = function () {
        this.client.end();
        this.client = null;
    };
    MqttClient.prototype.sendPresence = function () {
        this.client.publish("dscid/" + this.appState.dscid + "/presence/dscaid/" + this.appState.dscaid, JSON.stringify({
            apiVersion: "presence/v1",
            type: "setPresence",
            data: {
                presence: __WEBPACK_IMPORTED_MODULE_3__stores__["b" /* PresenceState */].ONLINE,
                note: ""
            },
        }));
    };
    MqttClient.prototype.handleMessage = function (topic, payload) {
        var msg = JSON.parse(payload.toString());
        switch (msg.apiVersion) {
            case "presence/v1":
                this.presenceStore.handleMqttMessage(topic, msg);
                break;
            default:
                console.log("unknown MQTT:", topic, msg.apiVersion, msg.type);
                break;
        }
    };
    __decorate([
        __WEBPACK_IMPORTED_MODULE_5_mobx__["i" /* observable */],
        __metadata("design:type", Number)
    ], MqttClient.prototype, "state", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_autobind_decorator___default.a,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], MqttClient.prototype, "sendPresence", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_autobind_decorator___default.a,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, Buffer]),
        __metadata("design:returntype", void 0)
    ], MqttClient.prototype, "handleMessage", null);
    return MqttClient;
}());


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(68).Buffer))

/***/ }),

/***/ 347:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Avatar;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return OnlineStatus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fortawesome_react_fontawesome__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fortawesome_react_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__fortawesome_react_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_fontawesome_pro_light__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_fontawesome_pro_light___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__fortawesome_fontawesome_pro_light__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_index__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Avatar_scss__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Avatar_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Avatar_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};







function Avatar(props) {
    var size = props.size || 30;
    var isCompany = props.isCompany || false;
    var icon = isCompany ? __WEBPACK_IMPORTED_MODULE_2__fortawesome_fontawesome_pro_light__["faBuilding"] : __WEBPACK_IMPORTED_MODULE_2__fortawesome_fontawesome_pro_light__["faUser"];
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_5__Avatar_scss___default.a.avatar, style: {
            width: size + "px",
            height: size + "px",
            backgroundImage: props.url ? "url(" + props.url + ")" : "none",
        } },
        props.url ?
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: props.url, style: { width: "100%", height: "100%", opacity: 0 } })
            :
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__fortawesome_react_fontawesome___default.a, { icon: icon, style: {
                        display: "block",
                        margin: "20% auto",
                        width: "60%",
                        height: "60%",
                    } }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](OnlineStatus, { size: size * 0.25, dscaid: props.dscaid, className: __WEBPACK_IMPORTED_MODULE_5__Avatar_scss___default.a.avatarOnlineStatus })));
}
var OnlineStatus = /** @class */ (function (_super) {
    __extends(OnlineStatus, _super);
    function OnlineStatus(props) {
        return _super.call(this, props) || this;
    }
    OnlineStatus.prototype.render = function () {
        var size = this.props.size || 10;
        var presence = __WEBPACK_IMPORTED_MODULE_4__lib_index__["c" /* PresenceState */].OFFLINE;
        if (this.props.dscaid && this.props.presenceStore.userPresence.has(this.props.dscaid)) {
            presence = this.props.presenceStore.userPresence.get(this.props.dscaid).presence;
        }
        switch (presence) {
            case __WEBPACK_IMPORTED_MODULE_4__lib_index__["c" /* PresenceState */].CONNECTION_PROBLEM:
                return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__fortawesome_react_fontawesome___default.a, { icon: "bolt", style: this.props.style, className: (this.props.className || "") + " " + __WEBPACK_IMPORTED_MODULE_5__Avatar_scss___default.a.onlineStatus + " " + __WEBPACK_IMPORTED_MODULE_5__Avatar_scss___default.a.connectionProblem }));
            case __WEBPACK_IMPORTED_MODULE_4__lib_index__["c" /* PresenceState */].ONLINE:
                return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: __WEBPACK_IMPORTED_MODULE_6_lodash__["assign"]({ width: size, height: size }, this.props.style), className: (this.props.className || "") + " " + __WEBPACK_IMPORTED_MODULE_5__Avatar_scss___default.a.onlineStatus + " " + __WEBPACK_IMPORTED_MODULE_5__Avatar_scss___default.a.online }));
            /*
            case PresenceState.OFFLINE:
                return (
                    <div
                        className = {`${styles.onlineStatus} ${styles.offline}`}
                        style={{
                            width: this.props.size * 0.25,
                            height: this.props.size * 0.25,
                    }}/>
                );
            */
            default:
                return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null);
        }
    };
    OnlineStatus = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["b" /* inject */])("presenceStore"),
        __WEBPACK_IMPORTED_MODULE_3_mobx_react__["c" /* observer */],
        __metadata("design:paramtypes", [Object])
    ], OnlineStatus);
    return OnlineStatus;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));



/***/ }),

/***/ 355:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FP_WEB", function() { return FP_WEB; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_es6_map__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_es6_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_es6_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_es6_set__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_es6_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_es6_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_es6_symbol__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_es6_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_es6_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_intl__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_intl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_intl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_intl_locale_data_jsonp_en__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_intl_locale_data_jsonp_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_intl_locale_data_jsonp_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_whatwg_fetch__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_whatwg_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_whatwg_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_select_dist_react_select_css__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_select_dist_react_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_select_dist_react_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_index__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lib_index__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__fortawesome_fontawesome__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__fortawesome_fontawesome_pro_brands__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__fortawesome_fontawesome_pro_brands___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__fortawesome_fontawesome_pro_brands__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__fortawesome_fontawesome_pro_light__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__fortawesome_fontawesome_pro_light___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__fortawesome_fontawesome_pro_light__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__fortawesome_fontawesome_pro_regular__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__fortawesome_fontawesome_pro_solid__ = __webpack_require__(94);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
// polyfills






window.Intl = __WEBPACK_IMPORTED_MODULE_3_intl__;
// other stuff






 //, MediaApiDropHandler





// fleetplan wants a older underscore version
__WEBPACK_IMPORTED_MODULE_7_lodash__["noConflict"]();
// tslint:disable-next-line:no-string-literal
var FP_WEB = window["FP_WEB"] = {
    FpId: __WEBPACK_IMPORTED_MODULE_12__lib_index__["a" /* FpId */],
    LIB_INSTANCES: __WEBPACK_IMPORTED_MODULE_12__lib_index__["b" /* LIB_INSTANCES */],
    render: function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var domEl, otherModule, ViewClass, reactEl;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        domEl = typeof options.el === "string"
                            ? document.querySelector(options.el)
                            : options.el;
                        if (domEl == null) {
                            // TODO: use log
                            console.error("FP_WEB: el not found", options);
                            throw new Error("FP_WEB: el not found: " + options.el);
                        }
                        if (!(options.module === "common")) return [3 /*break*/, 1];
                        otherModule = __WEBPACK_IMPORTED_MODULE_11__common__;
                        return [3 /*break*/, 3];
                    case 1:
                        // show a spinner while we lazy load the missing script
                        __WEBPACK_IMPORTED_MODULE_9_react_dom__["render"](__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__common_index__["ActivityIndicator"], { size: "lg" }), domEl);
                        return [4 /*yield*/, __webpack_require__(603)("./" + options.module + "/index")];
                    case 2:
                        otherModule = _a.sent();
                        _a.label = 3;
                    case 3:
                        ViewClass = otherModule[options.view];
                        reactEl = __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__common_index__["FpProvider"], null,
                            __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](ViewClass, __assign({}, options.props)));
                        __WEBPACK_IMPORTED_MODULE_9_react_dom__["render"](reactEl, domEl);
                        return [2 /*return*/];
                }
            });
        });
    },
};
//new MediaApiDropHandler();


/***/ }),

/***/ 387:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 403:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ActivityIndicator;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ActivityIndicator_scss__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ActivityIndicator_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ActivityIndicator_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_brand_icon200_png__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_brand_icon200_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__static_brand_icon200_png__);



function ActivityIndicator(props) {
    var useIcon = props.useIcon;
    var color = props.color || "#03a9f4";
    var size = props.size || "sm";
    switch (size) {
        case "sm":
            size = 16;
            break;
        case "lg":
            size = 50;
            break;
    }
    // if not defined, use fleetplan icon for big indicators
    if (useIcon == null && size > 32) {
        useIcon = true;
    }
    var content = "";
    var spinClass = __WEBPACK_IMPORTED_MODULE_1__ActivityIndicator_scss___default.a.spin;
    if (useIcon) {
        spinClass += " " + __WEBPACK_IMPORTED_MODULE_1__ActivityIndicator_scss___default.a.slow;
        content = __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: __WEBPACK_IMPORTED_MODULE_2__static_brand_icon200_png___default.a, height: "100%", width: "100%" });
    }
    else {
        content = __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("svg", { viewBox: "0 0 32 32", height: "100%", width: "100%" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("circle", { cx: "16", cy: "16", fill: "none", r: "14", strokeWidth: "4", style: { stroke: color, opacity: 0.2 } }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("circle", { cx: "16", cy: "16", fill: "none", r: "14", strokeWidth: "4", style: { stroke: color, strokeDasharray: 80, strokeDashoffset: 60 } }));
    }
    var boxSize = { width: size + "px", height: size + "px" };
    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { className: spinClass, style: boxSize }, content);
}


/***/ }),

/***/ 404:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(405);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(35)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./ActivityIndicator.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./ActivityIndicator.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 405:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(34)(undefined);
// imports


// module
exports.push([module.i, ".spin--3MMoQ {\n  display: inline-block;\n  line-height: 1;\n  animation-timing-function: linear;\n  animation-name: spinAnimation--3Qavb;\n  animation-iteration-count: infinite;\n  animation-duration: 0.75s; }\n  .spin--3MMoQ.slow--3mw3W {\n    animation-duration: 2s; }\n\n.paused--37rbr {\n  animation-play-state: paused; }\n\n@keyframes spinAnimation--3Qavb {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n", ""]);

// exports
exports.locals = {
	"spin": "spin--3MMoQ",
	"spinAnimation": "spinAnimation--3Qavb",
	"slow": "slow--3mw3W",
	"paused": "paused--37rbr"
};

/***/ }),

/***/ 406:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StatusPageWidget; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__StatusPageWidget_scss__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__StatusPageWidget_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__StatusPageWidget_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_brand_logo_png__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_brand_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__static_brand_logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__static_brand_icon200_png__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__static_brand_icon200_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__static_brand_icon200_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fortawesome_fontawesome_pro_light__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fortawesome_fontawesome_pro_light___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__fortawesome_fontawesome_pro_light__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__fortawesome_fontawesome_pro_solid__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fortawesome_react_fontawesome__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fortawesome_react_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__fortawesome_react_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StatusPage__ = __webpack_require__(208);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



//import testData from "./testdata.json";







var StatusPageWidget = /** @class */ (function (_super) {
    __extends(StatusPageWidget, _super);
    function StatusPageWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        return _this;
    }
    StatusPageWidget.prototype.render = function () {
        // in case there was no data -> setState takes some time (is async)
        var status = this.props.statusPageStore.status;
        var date = this.props.statusPageStore.date;
        if (!status) {
            var popover = __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["q" /* Popover */], { className: __WEBPACK_IMPORTED_MODULE_3__StatusPageWidget_scss___default.a.statusWidget, id: "popover", title: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](StatusWidgetTitle, { date: date }) },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__StatusPage__["a" /* StatusPageError */], null));
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["o" /* OverlayTrigger */], { trigger: "click", rootClose: true, placement: "top", overlay: popover },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: __WEBPACK_IMPORTED_MODULE_3__StatusPageWidget_scss___default.a.indicator },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](FpLogo, null),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: __WEBPACK_IMPORTED_MODULE_3__StatusPageWidget_scss___default.a.statusBadges + " " + __WEBPACK_IMPORTED_MODULE_3__StatusPageWidget_scss___default.a.err },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "fa-stack fa-lg" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__fortawesome_react_fontawesome___default.a, { icon: __WEBPACK_IMPORTED_MODULE_6__fortawesome_fontawesome_pro_light__["faWifi"], className: "fa-stack-2x", style: { fontSize: "8px", color: "black" } }),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__fortawesome_react_fontawesome___default.a, { icon: __WEBPACK_IMPORTED_MODULE_7__fortawesome_fontawesome_pro_solid__["h" /* faTimes */], className: "fa fa-stack-2x", style: { paddingLeft: "10px", paddingTop: "15px", fontSize: "12px", color: "red" } })))))));
        }
        var ins;
        var main;
        var popoverClickHasInfAboutIncidents;
        /*loops*/
        // loop over incidents
        try {
            ins = __WEBPACK_IMPORTED_MODULE_9__StatusPage__["b" /* StatusPageMessageGenerator */].getIncidents(status, 11, true);
            main = __WEBPACK_IMPORTED_MODULE_9__StatusPage__["b" /* StatusPageMessageGenerator */].getMaintence(status, 11, true);
            // loop over maintenances
            /*popovers*/
            // -> This will be used in case there are incidents or maintenances
            popoverClickHasInfAboutIncidents = (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["q" /* Popover */], { className: __WEBPACK_IMPORTED_MODULE_3__StatusPageWidget_scss___default.a.statusWidget, id: "popover", title: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](StatusWidgetTitle, { date: date }) },
                ins,
                ((status.scheduled_maintenances.length > 0) && (status.incidents.length > 0)) && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("hr", { className: __WEBPACK_IMPORTED_MODULE_3__StatusPageWidget_scss___default.a.hrStatus }),
                main));
        }
        catch (err) {
            if (err === "TypeError") {
                popoverClickHasInfAboutIncidents = (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["q" /* Popover */], { className: __WEBPACK_IMPORTED_MODULE_3__StatusPageWidget_scss___default.a.statusWidget, id: "popover", title: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](StatusWidgetTitle, { date: date }) },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__StatusPage__["a" /* StatusPageError */], { fontSize: 10 })));
            }
        }
        var warnings = 0;
        //now calculate some numbers and set a bool
        // show badge?
        warnings += status.incidents.length;
        warnings += status.scheduled_maintenances.length;
        //add auto generated incident when there is no information about the current incident
        if ((status.incidents.length === 0) && (status.status.indicator !== "none")) {
            warnings += 1;
        }
        /*return statement -> This will be rendered*/
        return (
        //this is the trigger for opening the window
        warnings > 0 ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["o" /* OverlayTrigger */], { trigger: "click", rootClose: true, placement: "top", overlay: popoverClickHasInfAboutIncidents },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: __WEBPACK_IMPORTED_MODULE_3__StatusPageWidget_scss___default.a.indicator }, warnings > 0 ?
                // <span className = {styles.status}>
                // 	<span className = {`${styles.statusBadges} ${styles[data.status.indicator]}`}>{warnings}</span>
                // 	{" "}{data.status.description}
                // </span>
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](FpLogo, null),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: __WEBPACK_IMPORTED_MODULE_3__StatusPageWidget_scss___default.a.statusBadges + " " + __WEBPACK_IMPORTED_MODULE_3__StatusPageWidget_scss___default.a[status.status.indicator] }, warnings))
                :
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](FpLogo, null),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: __WEBPACK_IMPORTED_MODULE_3__StatusPageWidget_scss___default.a.colorDot + " " + __WEBPACK_IMPORTED_MODULE_3__StatusPageWidget_scss___default.a[status.status.indicator] }))))
            : //when we have no warnings: do not use OverlayTrigger
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "http://status.fleetplan.net/", target: "_blank" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: __WEBPACK_IMPORTED_MODULE_3__StatusPageWidget_scss___default.a.indicator },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](FpLogo, null),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: __WEBPACK_IMPORTED_MODULE_3__StatusPageWidget_scss___default.a.colorDot + " " + __WEBPACK_IMPORTED_MODULE_3__StatusPageWidget_scss___default.a[status.status.indicator] })))));
    };
    StatusPageWidget = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["b" /* inject */])("statusPageStore"),
        __WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* observer */],
        __metadata("design:paramtypes", [Object])
    ], StatusPageWidget);
    return StatusPageWidget;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));

/**
 * This is the component that represents the title
 */
var StatusWidgetTitle = /** @class */ (function (_super) {
    __extends(StatusWidgetTitle, _super);
    function StatusWidgetTitle(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            date: _this.props.date,
        };
        return _this;
    }
    StatusWidgetTitle.prototype.render = function () {
        var date = this.state.date;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { style: { fontSize: 10 }, target: "_blank", href: "http://status.fleetplan.net/" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: __WEBPACK_IMPORTED_MODULE_5__static_brand_icon200_png___default.a, style: { height: "12px", width: "12px", paddingBottom: "2px" } }),
                " ",
                "statuspage.io"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: __WEBPACK_IMPORTED_MODULE_3__StatusPageWidget_scss___default.a.statusDate },
                " Last update:",
                " ",
                date.getHours(),
                ":",
                date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes())));
    };
    return StatusWidgetTitle;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
var FpLogo = /** @class */ (function (_super) {
    __extends(FpLogo, _super);
    function FpLogo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FpLogo.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: __WEBPACK_IMPORTED_MODULE_4__static_brand_logo_png___default.a, style: { height: "28px", padding: "6px 17px 3px", marginTop: "1px" } }));
    };
    return FpLogo;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));


/***/ }),

/***/ 545:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(34)(undefined);
// imports


// module
exports.push([module.i, "@charset \"UTF-8\";\n.colorDot--3d356 {\n  width: 15px;\n  height: 30px;\n  margin: 1px;\n  float: right; }\n  .colorDot--3d356.critical--ekX88 {\n    background-color: #e74c3c; }\n  .colorDot--3d356.major--3nPnL {\n    background-color: #e67e22; }\n  .colorDot--3d356.minor--1IO-4 {\n    background-color: #f1c40f; }\n  .colorDot--3d356.none--7yWUd {\n    background-color: #2ecc71; }\n  .colorDot--3d356.error --1OZSX {\n    background-color: #ffffff; }\n\n.indicator--1OUbi {\n  cursor: pointer; }\n\n.statusDate--fXhWU {\n  font-size: 10px;\n  font-style: italic;\n  color: grey;\n  margin: 0px;\n  line-height: 0.75;\n  padding-left: 14px; }\n\n.statusWidget--1VbS3 {\n  width: 250px; }\n\n.statusWidgetText--2xN0g {\n  display: block;\n  line-height: 1.4; }\n\n.status--1N5lm {\n  color: #8f90a5;\n  font-size: 9px; }\n\n.hrStatus--1DMc9 {\n  margin: 10px -15px; }\n\n.statusBadges--2P-wF {\n  line-height: 30px;\n  min-width: 15px;\n  height: 30px;\n  padding: 1px 5px;\n  color: white;\n  font-size: 10px;\n  float: right;\n  margin: 1px; }\n  .statusBadges--2P-wF.critical--ekX88 {\n    background-color: #e74c3c; }\n  .statusBadges--2P-wF.major--3nPnL {\n    background-color: #e67e22; }\n  .statusBadges--2P-wF.minor--1IO-4 {\n    background-color: #f1c40f; }\n  .statusBadges--2P-wF.none--7yWUd {\n    background-color: #2ecc71; }\n\n.noReports--1mdKc {\n  font-style: italic;\n  color: #8f90a5;\n  font-size: 12px; }\n\n.fleetplanLabel--1g_ct {\n  font-size: 12px; }\n", ""]);

// exports
exports.locals = {
	"colorDot": "colorDot--3d356",
	"critical": "critical--ekX88",
	"major": "major--3nPnL",
	"minor": "minor--1IO-4",
	"none": "none--7yWUd",
	"error ": "error --1OZSX",
	"indicator": "indicator--1OUbi",
	"statusDate": "statusDate--fXhWU",
	"statusWidget": "statusWidget--1VbS3",
	"statusWidgetText": "statusWidgetText--2xN0g",
	"status": "status--1N5lm",
	"hrStatus": "hrStatus--1DMc9",
	"statusBadges": "statusBadges--2P-wF",
	"noReports": "noReports--1mdKc",
	"fleetplanLabel": "fleetplanLabel--1g_ct"
};

/***/ }),

/***/ 546:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fcca12a3612908c63d0029c0ca3620ef.png";

/***/ }),

/***/ 547:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NotificationCenter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fortawesome_react_fontawesome__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fortawesome_react_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__fortawesome_react_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NotificationCenter_scss__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NotificationCenter_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__NotificationCenter_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_autobind_decorator__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_autobind_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_autobind_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_timezone__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_api_SystemNotificationApi__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_index__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__fortawesome_fontawesome_pro_light__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__fortawesome_fontawesome_pro_light___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__fortawesome_fontawesome_pro_light__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__ = __webpack_require__(72);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
//Dummydata:
/*

    Important data for this Notification Center are:
        - created
        - flags
        - sourceIcon
        - sourceName
        - title
        - content
        - dsLoader (handle on click)


*/
var notifi = [{
        id: __WEBPACK_IMPORTED_MODULE_6__lib_index__["a" /* FpId */].new(),
        msgKey: __WEBPACK_IMPORTED_MODULE_6__lib_index__["a" /* FpId */].new(),
        created: +new Date("Wed Aug 23 2017 18:57:30 GMT+0200 (CEST)"),
        deleted: null,
        dscaid: 12345,
        dscid: 5030,
        flags: 1,
        sourceIcon: "print",
        sourceName: "Print",
        title: "Bookings.pdf",
        content: "generating PDF FIle...",
        htmlContent: null,
        firstRead: null,
        deliveryMethod: __WEBPACK_IMPORTED_MODULE_5__lib_api_SystemNotificationApi__["b" /* SystemNotificationDeliveryMethod */].PUSH,
        deliveries: [{
                id: __WEBPACK_IMPORTED_MODULE_6__lib_index__["a" /* FpId */].new(),
                method: __WEBPACK_IMPORTED_MODULE_5__lib_api_SystemNotificationApi__["b" /* SystemNotificationDeliveryMethod */].PUSH,
                send: +new Date("Wed Aug 23 2017 01:57:30 GMT+0200 (CEST)"),
                read: null,
            }],
        dsLoader: {
            element: "",
            target: "dsloader",
            url: "/dynasite.cfm`dscmd=mediaapi_mediapi_mediaapi_download&id=12345"
        },
    }, {
        id: __WEBPACK_IMPORTED_MODULE_6__lib_index__["a" /* FpId */].new(),
        msgKey: __WEBPACK_IMPORTED_MODULE_6__lib_index__["a" /* FpId */].new(),
        created: +new Date().setHours(new Date().getHours() - 3),
        deleted: null,
        dscaid: 12345,
        dscid: 5030,
        flags: 0,
        sourceIcon: "calendar",
        sourceName: "Advanced Calendar",
        title: "Meeting",
        content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod" +
            " tempor incididunt ut labore et dolore magna aliqua. Cras pulvinar mattis nunc sed blandit libero volutpat.",
        htmlContent: null,
        firstRead: null,
        deliveryMethod: __WEBPACK_IMPORTED_MODULE_5__lib_api_SystemNotificationApi__["b" /* SystemNotificationDeliveryMethod */].PUSH,
        deliveries: [{
                id: __WEBPACK_IMPORTED_MODULE_6__lib_index__["a" /* FpId */].new(),
                method: __WEBPACK_IMPORTED_MODULE_5__lib_api_SystemNotificationApi__["b" /* SystemNotificationDeliveryMethod */].PUSH,
                send: +new Date(),
                read: null,
            }],
        dsLoader: {
            element: "",
            target: "dsloader",
            url: "/dynasite.cfm`dscmd=mediaapi_mediapi_mediaapi_download&id=12345"
        },
    }, {
        id: __WEBPACK_IMPORTED_MODULE_6__lib_index__["a" /* FpId */].new(),
        msgKey: __WEBPACK_IMPORTED_MODULE_6__lib_index__["a" /* FpId */].new(),
        created: +new Date(),
        deleted: null,
        dscaid: 12345,
        dscid: 5030,
        flags: 0,
        sourceIcon: "envelope",
        sourceName: "Messaging",
        title: "You received a message",
        content: "User1 has send you a message",
        htmlContent: null,
        firstRead: null,
        deliveryMethod: __WEBPACK_IMPORTED_MODULE_5__lib_api_SystemNotificationApi__["b" /* SystemNotificationDeliveryMethod */].PUSH,
        deliveries: [{
                id: __WEBPACK_IMPORTED_MODULE_6__lib_index__["a" /* FpId */].new(),
                method: __WEBPACK_IMPORTED_MODULE_5__lib_api_SystemNotificationApi__["b" /* SystemNotificationDeliveryMethod */].PUSH,
                send: +new Date(),
                read: null,
            }],
        dsLoader: {
            element: "",
            target: "dsloader",
            url: "/dynasite.cfm`dscmd=mediaapi_mediapi_mediaapi_download&id=12345"
        },
    }, {
        id: __WEBPACK_IMPORTED_MODULE_6__lib_index__["a" /* FpId */].new(),
        msgKey: __WEBPACK_IMPORTED_MODULE_6__lib_index__["a" /* FpId */].new(),
        created: +new Date(new Date().setMinutes(new Date().getMinutes() - 3)),
        deleted: null,
        dscaid: 12345,
        dscid: 5030,
        flags: 0,
        sourceIcon: "bell",
        sourceName: "Certs and Docs",
        title: "Personalausweis will expire",
        content: "Personalausweis will expire in two days",
        htmlContent: null,
        firstRead: null,
        deliveryMethod: __WEBPACK_IMPORTED_MODULE_5__lib_api_SystemNotificationApi__["b" /* SystemNotificationDeliveryMethod */].PUSH,
        deliveries: [{
                id: __WEBPACK_IMPORTED_MODULE_6__lib_index__["a" /* FpId */].new(),
                method: __WEBPACK_IMPORTED_MODULE_5__lib_api_SystemNotificationApi__["b" /* SystemNotificationDeliveryMethod */].PUSH,
                send: +new Date(),
                read: null,
            }],
        dsLoader: {
            element: "",
            target: "dsloader",
            url: "/dynasite.cfm`dscmd=mediaapi_mediapi_mediaapi_download&id=12345"
        },
    }];









var NotificationCenter = /** @class */ (function (_super) {
    __extends(NotificationCenter, _super);
    function NotificationCenter(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            data: notifi
        };
        return _this;
    }
    // private updateAmountNotifications = () =>{
    // 	this.props.handleNotifications(this.state.data.length);
    // }
    NotificationCenter.prototype.sort = function () {
        // //this.setState({data : sortBy(this.state.data, [function(el) {return el.created; }])});
        var temp = this.state.data;
        temp.sort(function (x, y) {
            return y.created - x.created;
        });
        this.setState({ data: temp });
    };
    NotificationCenter.prototype.componentWillMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.sort();
                this.pullNewData();
                this.intervalId = setInterval(function () { _this.forceUpdate(); }, 60000); //1min -> Rerender to update time?
                this.intervalNotification = setInterval(function () { _this.pullNewData(); }, 1000); //update notifications every second
                return [2 /*return*/];
            });
        });
    };
    NotificationCenter.prototype.componentWillUnmount = function () {
        clearInterval(this.intervalId);
        clearInterval(this.intervalNotification);
    };
    NotificationCenter.prototype.remove = function (jsonObject) {
        var index = this.state.data.findIndex(function (el) {
            return el.id === jsonObject.id;
        });
        this.state.data.splice(index, 1);
        this.sort();
    };
    NotificationCenter.prototype.pullNewData = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // let data = await fetch(""); //fetch data
                // let jsonNotifications = await data.json();
                // this.setState({}
                // 		data:jsonNotifications,
                // });
                if (this.props.handleAmNotifications) {
                    this.props.handleAmNotifications(this.state.data.length); //update notifications
                }
                return [2 /*return*/];
            });
        });
    };
    NotificationCenter.prototype.render = function () {
        var _this = this;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: { display: "flex", flexFlow: "column", height: "100%" } },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: { flex: "1", minHeight: 0, overflow: "auto" } }, this.state.data.length > 0 ?
                this.state.data.map(function (data) {
                    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Notification, { key: data.id, data: data, onRead: _this.remove });
                })
                :
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_2__NotificationCenter_scss___default.a.noNotifications }, "No Notifications")),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "list-group-item " + " " + __WEBPACK_IMPORTED_MODULE_2__NotificationCenter_scss___default.a.showReadNoti },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "#" }, "Show read Notifications"))));
    };
    __decorate([
        __WEBPACK_IMPORTED_MODULE_3_autobind_decorator___default.a,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], NotificationCenter.prototype, "remove", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_3_autobind_decorator___default.a,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], NotificationCenter.prototype, "pullNewData", null);
    return NotificationCenter;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));

var Notification = /** @class */ (function (_super) {
    __extends(Notification, _super);
    function Notification(props) {
        var _this = _super.call(this, props) || this;
        /**
         * returns true, if the message is younger then one minute
         */
        //computed value?
        _this.displaAsyNew = function () {
            return ((new Date().getTime() - new Date(_this.props.data.created).getTime()) <= 6000) && !_this.state.didHover; //1min, 10 sec for testing
        };
        _this.reactToHover = function () {
            _this.setState({
                didHover: true,
            });
        };
        _this.state = {
            didHover: false,
        };
        return _this;
    }
    Notification.prototype.readNotification = function (e) {
        e.stopPropagation();
        if (this.isReadable()) {
            alert("read notification");
            this.props.onRead(this.props.data);
        }
    };
    Notification.prototype.markAsRead = function (e) {
        e.stopPropagation();
        if (this.isReadable()) {
            alert("this message will now be marked as read");
            this.props.onRead(this.props.data);
        }
    };
    Notification.prototype.isReadable = function () {
        return (this.props.data.flags & __WEBPACK_IMPORTED_MODULE_5__lib_api_SystemNotificationApi__["c" /* SystemNotificationFlags */].NOT_READABLE) === 0;
    };
    Notification.prototype.render = function () {
        var _this = this;
        var created = __WEBPACK_IMPORTED_MODULE_4_moment_timezone__(new Date(this.props.data.created));
        var now = __WEBPACK_IMPORTED_MODULE_4_moment_timezone__(new Date());
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { onClick: function (e) { return _this.readNotification(e); }, className: "list-group-item list-group-item-action " + __WEBPACK_IMPORTED_MODULE_2__NotificationCenter_scss___default.a.noBorder + " " + (this.displaAsyNew() ?
                __WEBPACK_IMPORTED_MODULE_2__NotificationCenter_scss___default.a.newNotification : "") + "\n\t\t\t\t", onMouseEnter: function () { return _this.reactToHover(); } },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: __WEBPACK_IMPORTED_MODULE_2__NotificationCenter_scss___default.a.headerNotification },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__fortawesome_react_fontawesome___default.a, { icon: this.props.data.sourceIcon }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "" + __WEBPACK_IMPORTED_MODULE_2__NotificationCenter_scss___default.a.headerNotification },
                        " " + this.props.data.sourceName,
                        " ",
                        this.displaAsyNew() ? " " : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null,
                            " ",
                            "\u2022",
                            " "))),
                this.displaAsyNew() ?
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "label label-success" }, "new")
                    :
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("small", { className: __WEBPACK_IMPORTED_MODULE_2__NotificationCenter_scss___default.a.timer }, created.from(now)),
                this.isReadable() ?
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["o" /* OverlayTrigger */], { placement: "right", overlay: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["r" /* Tooltip */], { id: "tooltip" }, "Mark as read") },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: __WEBPACK_IMPORTED_MODULE_2__NotificationCenter_scss___default.a.exitButton, onClick: function (e) { return _this.markAsRead(e); } },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__fortawesome_react_fontawesome___default.a, { icon: __WEBPACK_IMPORTED_MODULE_7__fortawesome_fontawesome_pro_light__["faTimes"] }))) : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("hr", { className: __WEBPACK_IMPORTED_MODULE_2__NotificationCenter_scss___default.a.hrNoti }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_2__NotificationCenter_scss___default.a.notiTitle }, this.props.data.title),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: __WEBPACK_IMPORTED_MODULE_2__NotificationCenter_scss___default.a.detail }, this.props.data.content))));
    };
    __decorate([
        __WEBPACK_IMPORTED_MODULE_3_autobind_decorator___default.a,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], Notification.prototype, "readNotification", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_3_autobind_decorator___default.a,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], Notification.prototype, "markAsRead", null);
    return Notification;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));


/***/ }),

/***/ 548:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(549);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(35)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./NotificationCenter.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./NotificationCenter.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 549:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(34)(undefined);
// imports


// module
exports.push([module.i, ".notifiTitle--QUfrs {\n  font-style: italic; }\n\n.notification--2jQuP {\n  cursor: pointer; }\n\n.hrNoti--1xHBY {\n  margin: 1px -1px; }\n\n.timer--vZMAN {\n  font-style: italic;\n  color: #8f8f8f;\n  font-size: 8px; }\n\n.detail--60cSL {\n  font-size: 11px;\n  line-height: 1.5;\n  height: 18px;\n  display: inline-block; }\n\n.notiTitle--1lXF0 {\n  font-size: 12px;\n  font-weight: bold; }\n\n.noNotifications--3KaNV {\n  color: rgba(0, 0, 0, 0.253);\n  font-style: italic;\n  font-size: 14px;\n  text-align: center;\n  padding-top: 60px;\n  padding-bottom: 60px; }\n\n.noBorder--33EBb {\n  -webkit-transition: 0.5s !important;\n  -moz-transition: 0.5s !important;\n  -o-transition: 0.5s !important;\n  transition: 0.5s !important;\n  border-right: none !important;\n  border-left: none !important;\n  border-top: none !important;\n  border-bottom: 2px solid #eeeeee !important; }\n  .noBorder--33EBb.newNotification--35XIe {\n    background: cornsilk !important; }\n\n.showReadNoti--1HzSH {\n  text-align: center !important;\n  padding-top: 2px !important;\n  padding-bottom: 2px !important;\n  border-bottom: none !important; }\n\n.content--1Hqgn {\n  overflow: auto; }\n\n.headerNotification--2KOr_ {\n  font-size: 10px;\n  font-weight: 0; }\n\n.exitButton--iaveT {\n  line-height: 17px;\n  padding: 1px 5px;\n  float: right; }\n\n.exitButton--iaveT:hover {\n  background: #e6e6e6; }\n\n.exitButton--iaveT:active {\n  background: #6b6b6b; }\n\n.nomousepointer--3hZ7S {\n  cursor: default; }\n", ""]);

// exports
exports.locals = {
	"notifiTitle": "notifiTitle--QUfrs",
	"notification": "notification--2jQuP",
	"hrNoti": "hrNoti--1xHBY",
	"timer": "timer--vZMAN",
	"detail": "detail--60cSL",
	"notiTitle": "notiTitle--1lXF0",
	"noNotifications": "noNotifications--3KaNV",
	"noBorder": "noBorder--33EBb",
	"newNotification": "newNotification--35XIe",
	"showReadNoti": "showReadNoti--1HzSH",
	"content": "content--1Hqgn",
	"headerNotification": "headerNotification--2KOr_",
	"exitButton": "exitButton--iaveT",
	"nomousepointer": "nomousepointer--3hZ7S"
};

/***/ }),

/***/ 553:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ApiClient; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ApiError__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SystemImportApi__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SystemNotificationApi__ = __webpack_require__(136);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};




var ApiClient = /** @class */ (function () {
    function ApiClient() {
        this.systemImport = new __WEBPACK_IMPORTED_MODULE_2__SystemImportApi__["a" /* SystemImportApi */](this);
        this.systemNotification = new __WEBPACK_IMPORTED_MODULE_3__SystemNotificationApi__["a" /* SystemNotificationApi */](this);
    }
    /**
     * Small wrapper around the `fetch` function, directly returns the json
     * @throws Will throw if the response isn't valid JSON
     * @param url url to fetch
     * @param init additional options passed to fetch function
     */
    ApiClient.prototype.fetchJson = function (url, init) {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetch(url, init)];
                    case 1:
                        res = _a.sent();
                        return [4 /*yield*/, res.json()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Makes a RPC call to the API
     * @param method PRC Method to call
     * @param params params Object to pass
     */
    ApiClient.prototype.callCfc = function (method, params) {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetchJson("/dynasite.cfm?dscmd=system_rpc_rpc_call", {
                            method: "post",
                            credentials: "include",
                            body: JSON.stringify({ method: method, params: params }),
                        })];
                    case 1:
                        res = _a.sent();
                        if (res.error != null) {
                            throw new __WEBPACK_IMPORTED_MODULE_1__ApiError__["a" /* ApiError */](res.error.code, res.error.message, res.error.data);
                        }
                        if (res.DEBUG != null) {
                            this.logSpan(res.DEBUG, res.DEBUG.requestId);
                        }
                        return [2 /*return*/, res.result];
                }
            });
        });
    };
    /**
     * Print debugging info about the given span to the `console`
     * @param DEBUG the DEBUG object returned from the Request
     * @param id ID of the span to print
     * @param indent internal param for recursion, set indention level
     */
    ApiClient.prototype.logSpan = function (DEBUG, id, indent) {
        if (indent === void 0) { indent = 0; }
        var thisSpan = __WEBPACK_IMPORTED_MODULE_0_lodash__["find"](DEBUG.spans, function (s) { return s.spanId === id; });
        // tslint:disable:no-console
        if (thisSpan == null) {
            console.log(__WEBPACK_IMPORTED_MODULE_0_lodash__["repeat"]("  ", indent) + ("- " + id));
        }
        else {
            console.log(__WEBPACK_IMPORTED_MODULE_0_lodash__["repeat"]("  ", indent) + ("- " + thisSpan.method + " (" + thisSpan.time + "ms)"));
        }
        // tslint:enable:no-console
        var spans = __WEBPACK_IMPORTED_MODULE_0_lodash__["filter"](DEBUG.spans, function (s) { return s.parent === id; });
        for (var _i = 0, spans_1 = spans; _i < spans_1.length; _i++) {
            var span = spans_1[_i];
            this.logSpan(DEBUG, span.spanId, indent + 1);
        }
    };
    return ApiClient;
}());



/***/ }),

/***/ 554:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppState; });
var AppState = /** @class */ (function () {
    function AppState() {
    }
    Object.defineProperty(AppState.prototype, "dscid", {
        get: function () { return parseInt(window["DSCID"]); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppState.prototype, "dscaid", {
        get: function () { return parseInt(window["DSCAID"]); },
        enumerable: true,
        configurable: true
    });
    return AppState;
}());



/***/ }),

/***/ 555:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PresenceState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PresenceStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx__ = __webpack_require__(33);
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var PresenceState;
(function (PresenceState) {
    PresenceState["ONLINE"] = "ONLINE";
    PresenceState["OFFLINE"] = "OFFLINE";
    PresenceState["CONNECTION_PROBLEM"] = "CONNECTION_PROBLEM";
})(PresenceState || (PresenceState = {}));
var PresenceStore = /** @class */ (function () {
    function PresenceStore() {
        var _this = this;
        this.myNote = "";
        this.userPresence = new Map();
        setTimeout(function () {
            _this.myNote = "ddd";
        }, 500);
    }
    PresenceStore.prototype.handleMqttMessage = function (topic, msg) {
        switch (msg.type) {
            case "event":
                if (msg.data.presence === PresenceState.OFFLINE) {
                    this.userPresence.delete(msg.data.dscaid);
                }
                else {
                    this.userPresence.set(msg.data.dscaid, msg.data);
                }
                break;
            case "state":
                var userPresence = new Map();
                for (var _i = 0, _a = msg.data; _i < _a.length; _i++) {
                    var presence = _a[_i];
                    userPresence.set(presence.dscaid, presence);
                }
                this.userPresence = userPresence;
                break;
            default:
                console.log("unknown MQTT:", topic, msg.apiVersion, msg.type);
                break;
        }
    };
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["i" /* observable */],
        __metadata("design:type", Object)
    ], PresenceStore.prototype, "myNote", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["i" /* observable */],
        __metadata("design:type", Object)
    ], PresenceStore.prototype, "userPresence", void 0);
    return PresenceStore;
}());



/***/ }),

/***/ 556:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SystemNotification */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SystemNotificationStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Entity__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(138);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var SystemNotification = /** @class */ (function (_super) {
    __extends(SystemNotification, _super);
    function SystemNotification() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Can this Notification be marked marked as read?
     */
    SystemNotification.prototype.isReadable = function () {
        return (this.flags & __WEBPACK_IMPORTED_MODULE_2__api__["b" /* SystemNotificationFlags */].NOT_READABLE) !== 0;
    };
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["i" /* observable */],
        __metadata("design:type", String)
    ], SystemNotification.prototype, "id", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["i" /* observable */],
        __metadata("design:type", String)
    ], SystemNotification.prototype, "msgKey", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["i" /* observable */],
        __metadata("design:type", Number)
    ], SystemNotification.prototype, "flags", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["i" /* observable */],
        __metadata("design:type", Number)
    ], SystemNotification.prototype, "dscid", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["i" /* observable */],
        __metadata("design:type", Number)
    ], SystemNotification.prototype, "dscaid", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["i" /* observable */],
        __metadata("design:type", Number)
    ], SystemNotification.prototype, "created", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["i" /* observable */],
        __metadata("design:type", Number)
    ], SystemNotification.prototype, "deleted", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["i" /* observable */],
        __metadata("design:type", String)
    ], SystemNotification.prototype, "sourceName", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["i" /* observable */],
        __metadata("design:type", String)
    ], SystemNotification.prototype, "sourceIcon", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["i" /* observable */],
        __metadata("design:type", String)
    ], SystemNotification.prototype, "title", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["i" /* observable */],
        __metadata("design:type", String)
    ], SystemNotification.prototype, "content", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["i" /* observable */],
        __metadata("design:type", String)
    ], SystemNotification.prototype, "htmlContent", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["i" /* observable */],
        __metadata("design:type", Object)
    ], SystemNotification.prototype, "dsLoader", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["i" /* observable */],
        __metadata("design:type", Number)
    ], SystemNotification.prototype, "firstRead", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["i" /* observable */],
        __metadata("design:type", Number)
    ], SystemNotification.prototype, "deliveryMethod", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["i" /* observable */],
        __metadata("design:type", Array)
    ], SystemNotification.prototype, "deliveries", void 0);
    return SystemNotification;
}(__WEBPACK_IMPORTED_MODULE_1__Entity__["a" /* Entity */]));

var SystemNotificationStore = /** @class */ (function () {
    function SystemNotificationStore(appState) {
        this.appState = appState;
        this.store = new Map();
    }
    Object.defineProperty(SystemNotificationStore.prototype, "myUnread", {
        get: function () {
            var _this = this;
            var result = [];
            this.store.forEach(function (value) {
                if (value.firstRead == null && value.dscaid === _this.appState.dscaid) {
                    result.push(value);
                }
            });
            return result;
        },
        enumerable: true,
        configurable: true
    });
    SystemNotificationStore.prototype.set = function (data, _a) {
        var _b = (_a === void 0 ? {} : _a).create, create = _b === void 0 ? true : _b;
        var current = this.store.get(data.id);
        if (current == null && create) {
            // not found in store
            current = new SystemNotification();
            this.store.set(data.id, current);
        }
        if (current != null) {
            // update model with new data
            current.assign(data);
        }
        return current;
    };
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["d" /* computed */],
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [])
    ], SystemNotificationStore.prototype, "myUnread", null);
    return SystemNotificationStore;
}());



/***/ }),

/***/ 557:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StatusPageStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_autobind_decorator__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_autobind_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_autobind_decorator__);
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};


// interface IStatus {
// 	components: any;
// 	incidents: [
// 		{
// 			created_at: string,
// 			id: string,
// 			impact: string,
// 			incident_updates: [
// 				{
// 					affected_components: any,
// 					body: string,
// 					custom_tweet: any,
// 					deliver_notifications: boolean,
// 					display_at: string,
// 					id: string,
// 					incident_id: string,
// 					status: string,
// 					updated_at: string,
// 				}
// 			]
// 			monitoring_at: any,
// 			name: string,
// 			page_id: string,
// 			resolved_at: any,
// 			scheduled_for: string,
// 			scheduled_until: string,
// 			shortlink: string,
// 			status: string,
// 			updated_at: string,
// 		}
// 	];
// 	page: any;
// 	scheduled_maintenances: [
// 		{
// 			created_at: string,
// 			id: string,
// 			impact: string,
// 			incident_updates: [
// 				{
// 					affected_components: any,
// 					body: string,
// 					custom_tweet: any,
// 					deliver_notifications: boolean,
// 					display_at: string,
// 					id: string,
// 					incident_id: string,
// 					status: string,
// 					updated_at: string,
// 				}
// 			]
// 			monitoring_at: any,
// 			name: string,
// 			page_id: string,
// 			resolved_at: any,
// 			scheduled_for: string,
// 			scheduled_until: string,
// 			shortlink: string,
// 			status: string,
// 			updated_at: string,
// 		}
// 	];
// 	status: {
// 		description: string,
// 		indicator: string,
// 	};
// }
var StatusPageStore = /** @class */ (function () {
    function StatusPageStore() {
        this.status = {
            "status": {
                "description": "none",
                "indicator": "none"
            },
            "incidents": [],
            "scheduled_maintenances": []
        };
        this.date = new Date();
        this.updateData();
        setInterval(this.updateData, 300000); //5min
    }
    StatusPageStore.prototype.updateData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, json, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, fetch("https://7183xkjgdkg1.statuspage.io/api/v2/summary.json")];
                    case 1:
                        data = _a.sent();
                        return [4 /*yield*/, data.json()];
                    case 2:
                        json = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        json = null;
                        return [3 /*break*/, 4];
                    case 4:
                        //json = null;
                        this.status = json;
                        this.date = new Date();
                        return [2 /*return*/];
                }
            });
        });
    };
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["i" /* observable */],
        __metadata("design:type", Object)
    ], StatusPageStore.prototype, "status", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["i" /* observable */],
        __metadata("design:type", Object)
    ], StatusPageStore.prototype, "date", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_autobind_decorator___default.a,
        __WEBPACK_IMPORTED_MODULE_0_mobx__["c" /* action */],
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], StatusPageStore.prototype, "updateData", null);
    return StatusPageStore;
}());



/***/ }),

/***/ 56:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LIB_INSTANCES; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(138);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stores__ = __webpack_require__(139);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__stores__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FpId__ = __webpack_require__(330);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__FpId__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MqttClient__ = __webpack_require__(331);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__instances__ = __webpack_require__(591);




//export * from "./MediaApiDropHandler";

/**
 * set once globally, will be reused by all instances of <FpProvider/>
 */
var LIB_INSTANCES = __WEBPACK_IMPORTED_MODULE_4__instances__;


/***/ }),

/***/ 563:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 586:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 587:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 591:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "apiClient", function() { return apiClient; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "appState", function() { return appState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "systemNotificationStore", function() { return systemNotificationStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "presenceStore", function() { return presenceStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "statusPageStore", function() { return statusPageStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mqttClient", function() { return mqttClient; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_index__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MqttClient__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stores_index__ = __webpack_require__(139);



var apiClient = new __WEBPACK_IMPORTED_MODULE_0__api_index__["a" /* ApiClient */]();
var appState = new __WEBPACK_IMPORTED_MODULE_2__stores_index__["a" /* AppState */]();
var systemNotificationStore = new __WEBPACK_IMPORTED_MODULE_2__stores_index__["e" /* SystemNotificationStore */](appState);
var presenceStore = new __WEBPACK_IMPORTED_MODULE_2__stores_index__["c" /* PresenceStore */]();
var statusPageStore = new __WEBPACK_IMPORTED_MODULE_2__stores_index__["d" /* StatusPageStore */]();
var mqttClient = new __WEBPACK_IMPORTED_MODULE_1__MqttClient__["a" /* MqttClient */](appState, presenceStore);


/***/ }),

/***/ 592:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OnlineList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Avatar_Avatar__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OnlineList_scss__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OnlineList_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__OnlineList_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_autobind_decorator__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_autobind_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_autobind_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_index__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mobx_react__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mobx__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fortawesome_react_fontawesome__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fortawesome_react_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__fortawesome_react_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__fortawesome_fontawesome_pro_light__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__fortawesome_fontawesome_pro_light___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__fortawesome_fontawesome_pro_light__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};









 //faChevronDown

var OnlineList = /** @class */ (function (_super) {
    __extends(OnlineList, _super);
    function OnlineList(props) {
        return _super.call(this, props) || this;
    }
    OnlineList.prototype.updateStatus = function (str) {
        this.props.presenceStore.myNote = str;
    };
    /**
     * Swaps loggedin user to the top
     */
    OnlineList.prototype.getMe = function () {
        var _this = this;
        var ret;
        this.props.presenceStore.userPresence.forEach(function (e, ind) {
            if (_this.props.appState.dscaid === e.dscaid) {
                ret = e;
                return;
            }
        });
        if (!ret) {
            // console.error(
            // 	`Error: 'Me' is ${ret}! Couldn't find ${this.props.appState.dscaid} in logged in users!
            // 	'User Online:' is showing a wrong number, because it is using the user online array`
            // );
            ret = {
                dscid: 0,
                dscaid: this.props.appState.dscaid,
                presence: __WEBPACK_IMPORTED_MODULE_5__lib_index__["c" /* PresenceState */].CONNECTION_PROBLEM,
                note: "You are offline",
                updated: 0,
            };
        }
        return ret;
    };
    OnlineList.prototype.componentWillUnmount = function () {
        clearInterval(this.intervalId);
    };
    OnlineList.prototype.sort = function (data) {
        return data.sort(function (x, y) {
            if (x.dscaid < y.dscaid)
                return -1;
            if (x.dscaid > y.dscaid)
                return 1;
            return 0;
        });
    };
    OnlineList.prototype.getUsersOnline = function () {
        return this.props.presenceStore.userPresence.size;
    };
    OnlineList.prototype.render = function () {
        var _this = this;
        //create proper json for looping
        var projectsObjects = {};
        this.props.presenceStore.userPresence.forEach(function (e) {
            if (projectsObjects[e.dscid] == null) {
                projectsObjects[e.dscid] = {
                    dscid: e.dscid,
                    onlineUsers: [],
                };
            }
            projectsObjects[e.dscid].onlineUsers.push(e);
        });
        var projects = __WEBPACK_IMPORTED_MODULE_10_lodash__["values"](projectsObjects);
        projects.forEach(function (e) {
            _this.sort(e.onlineUsers);
        });
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: { display: "flex", flexFlow: "column", height: "100%" } },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: { flex: "1", minHeight: 0, overflow: "auto" } },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "label label-primary " + __WEBPACK_IMPORTED_MODULE_3__OnlineList_scss___default.a.projectName, style: { display: "block" } },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__fortawesome_react_fontawesome___default.a, { className: "pull-right", style: { float: "right" }, icon: __WEBPACK_IMPORTED_MODULE_9__fortawesome_fontawesome_pro_light__["faWifi"] }),
                    "User Online: ",
                    this.getUsersOnline()),
                this.getMe() &&
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](User, { userInformation: this.getMe(), me: true, myNoteFunc: this.updateStatus }),
                projects.map(function (project) {
                    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { key: project.dscid },
                        projects.length > 1 &&
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "label label-primary " + __WEBPACK_IMPORTED_MODULE_3__OnlineList_scss___default.a.projectName }, project.dscid),
                        project.onlineUsers.map(function (user) {
                            return !(user.dscaid === _this.props.appState.dscaid) && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](User, { key: user.dscaid, userInformation: user, me: false, myNoteFunc: _this.updateStatus });
                        }));
                }),
                (this.getUsersOnline() <= 1 || this.getMe().dsaid === 0) && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "" + __WEBPACK_IMPORTED_MODULE_3__OnlineList_scss___default.a.noUserOnline }, "No user online"))));
    };
    __decorate([
        __WEBPACK_IMPORTED_MODULE_4_autobind_decorator___default.a,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], OnlineList.prototype, "updateStatus", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_4_autobind_decorator___default.a,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], OnlineList.prototype, "getMe", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_4_autobind_decorator___default.a,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], OnlineList.prototype, "getUsersOnline", null);
    OnlineList = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_6_mobx_react__["b" /* inject */])("presenceStore", "appState"),
        __WEBPACK_IMPORTED_MODULE_6_mobx_react__["c" /* observer */],
        __metadata("design:paramtypes", [Object])
    ], OnlineList);
    return OnlineList;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));

var User = /** @class */ (function (_super) {
    __extends(User, _super);
    function User(props) {
        var _this = _super.call(this, props) || this;
        _this.open = false;
        return _this;
    }
    User.prototype.isMe = function (dscaid) {
        return this.props.me;
    };
    User.prototype.expand = function () {
        this.open = !this.open;
    };
    User.prototype.openProfile = function () {
        dsloader("dynasite.cfm?dscmd=contact_contact_contact_detail&dscaid=" + this.props.userInformation.dscaid, "tab", "contact_contact_contact_detail_" + this.props.userInformation.dscaid, "xhr:1");
    };
    User.prototype.render = function () {
        var _this = this;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            this.isMe(this.props.userInformation.dscaid) ?
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: { textAlign: "center" } },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: { padding: "5px 0 0 0" }, className: __WEBPACK_IMPORTED_MODULE_3__OnlineList_scss___default.a.centerAvatar },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { onClick: function () { return _this.expand(); }, className: " " + __WEBPACK_IMPORTED_MODULE_3__OnlineList_scss___default.a.buttonDown, style: { padding: "5px" } },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__Avatar_Avatar__["a" /* Avatar */], { url: "", size: 50, dscaid: this.props.userInformation.dscid ?
                                    this.props.userInformation.dscaid :
                                    0 }))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "javascript:void(0)", onClick: function (e) { e.stopPropagation(); _this.openProfile(); } }, this.props.userInformation.dscaid /*change later to name*/),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: __WEBPACK_IMPORTED_MODULE_3__OnlineList_scss___default.a.description, style: { paddingBottom: "8px", marginTop: "-15px" } },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Userstatus, { status: this.props.userInformation.note, isMe: this.isMe(this.props.userInformation.dscaid), statusFunc: this.props.myNoteFunc }))) :
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "list-group-item list-group-item-action " + __WEBPACK_IMPORTED_MODULE_3__OnlineList_scss___default.a.noBorder, style: { display: "flex", flexFlow: "row", padding: "8px 0 0 15px" } },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: { flex: "0 0 auto", padding: "3px 0" } },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__Avatar_Avatar__["a" /* Avatar */], { url: "", size: 37, dscaid: this.props.userInformation.dscid ? this.props.userInformation.dscaid : 0 })),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: { flex: "1", paddingTop: "3px", paddingLeft: "6px" } },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: __WEBPACK_IMPORTED_MODULE_3__OnlineList_scss___default.a.buttonDown + " " + __WEBPACK_IMPORTED_MODULE_3__OnlineList_scss___default.a.buttonOnRight, onClick: function () { return _this.expand(); } },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__fortawesome_react_fontawesome___default.a, { key: this.open ? "x" : "y", icon: this.open ? __WEBPACK_IMPORTED_MODULE_9__fortawesome_fontawesome_pro_light__["faChevronUp"] : __WEBPACK_IMPORTED_MODULE_9__fortawesome_fontawesome_pro_light__["faChevronDown"] })),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: __WEBPACK_IMPORTED_MODULE_3__OnlineList_scss___default.a.description },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "javascript:void(0)", onClick: function (e) { e.stopPropagation(); _this.openProfile(); } }, this.props.userInformation.dscaid),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Userstatus, { status: this.props.userInformation.note, isMe: this.isMe(this.props.userInformation.dscaid), statusFunc: this.props.myNoteFunc })))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["p" /* Panel */], { collapsible: true, expanded: this.open, style: {
                    padding: "0 15px " + ((this.props.me ? "0" : "10px") + " 0"),
                    margin: "0",
                    borderTop: "" + (!this.open && this.props.me ? "none" : "1px solid #ddd")
                } },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: { padding: "0" } },
                    !(this.props.me) &&
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("hr", { className: __WEBPACK_IMPORTED_MODULE_3__OnlineList_scss___default.a.hrUser }),
                    " ",
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("table", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tbody", { className: __WEBPACK_IMPORTED_MODULE_3__OnlineList_scss___default.a.userdetails },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tr", null,
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", null, "Mobile:"),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", null,
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "tel:" }, this.props.userInformation.dscaid)),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", null,
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { onClick: function () { return _this.copyTextToClipboard("" + _this.props.userInformation.dscid); }, className: __WEBPACK_IMPORTED_MODULE_3__OnlineList_scss___default.a.clipboard },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__fortawesome_react_fontawesome___default.a, { icon: __WEBPACK_IMPORTED_MODULE_9__fortawesome_fontawesome_pro_light__["faClipboard"] })))),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tr", null,
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", null, "Phone:"),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", null,
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "tel:" }, this.props.userInformation.dscaid)),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", null,
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { onClick: function () { return _this.copyTextToClipboard("" + _this.props.userInformation.dscid); }, className: __WEBPACK_IMPORTED_MODULE_3__OnlineList_scss___default.a.clipboard },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__fortawesome_react_fontawesome___default.a, { icon: __WEBPACK_IMPORTED_MODULE_9__fortawesome_fontawesome_pro_light__["faClipboard"] })))),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tr", null,
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", null, "Mail:"),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", null,
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "mailto:" }, this.props.userInformation.dscaid)),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", null,
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { onClick: function () { return _this.copyTextToClipboard("" + _this.props.userInformation.dscid); }, className: __WEBPACK_IMPORTED_MODULE_3__OnlineList_scss___default.a.clipboard },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__fortawesome_react_fontawesome___default.a, { icon: __WEBPACK_IMPORTED_MODULE_9__fortawesome_fontawesome_pro_light__["faClipboard"] }))))))))));
    };
    User.prototype.copyTextToClipboard = function (text) {
        var textArea = document.createElement("textarea");
        textArea.style.background = "transparent";
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.select();
        try {
            document.execCommand("copy");
        }
        catch (err) {
            alert("Something went wrong (Failed to copy)");
        }
        document.body.removeChild(textArea);
    };
    __decorate([
        __WEBPACK_IMPORTED_MODULE_7_mobx__["i" /* observable */],
        __metadata("design:type", Boolean)
    ], User.prototype, "open", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_7_mobx__["c" /* action */],
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], User.prototype, "expand", null);
    User = __decorate([
        __WEBPACK_IMPORTED_MODULE_6_mobx_react__["c" /* observer */],
        __metadata("design:paramtypes", [Object])
    ], User);
    return User;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
var Userstatus = /** @class */ (function (_super) {
    __extends(Userstatus, _super);
    function Userstatus(props) {
        var _this = _super.call(this, props) || this;
        _this.editmode = false;
        _this.status = _this.props.status;
        return _this;
        // console.log(this.props.isMe);
    }
    Userstatus.prototype.onChangeStatus = function (e) {
        this.status = e.target.value;
    };
    Userstatus.prototype.switchEditmode = function (e) {
        e.stopPropagation();
        if (this.props.isMe) {
            this.editmode = !this.editmode;
        }
    };
    Userstatus.prototype.saveChanges = function (e) {
        this.props.statusFunc(this.status);
        this.switchEditmode(e);
    };
    //-> impl save method that changes the Profile_Message global
    Userstatus.prototype.render = function () {
        var _this = this;
        return (this.editmode ?
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["i" /* InputGroup */], { bsSize: "small", style: { width: "120px" } },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["g" /* FormControl */], { onChange: function (e) { return _this.onChangeStatus(e); }, type: "text", placeholder: "max 30 signs...", value: this.status, onKeyDown: function (e) {
                        if (e.keyCode === 13) {
                            _this.saveChanges(e);
                        }
                    }, style: { height: "25px" }, maxLength: 30 }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["i" /* InputGroup */].Button, null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["b" /* Button */], { style: { height: "25px", padding: "0 8px 0 8px" }, onClick: function (e) { return _this.saveChanges(e); }, bsStyle: "success" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__fortawesome_react_fontawesome___default.a, { icon: __WEBPACK_IMPORTED_MODULE_9__fortawesome_fontawesome_pro_light__["faCheck"] }))))
            :
                this.status ?
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: __WEBPACK_IMPORTED_MODULE_3__OnlineList_scss___default.a.status, onClick: function (e) {
                            return _this.switchEditmode(e);
                        } }, this.status) :
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: __WEBPACK_IMPORTED_MODULE_3__OnlineList_scss___default.a.status, onClick: function (e) {
                            return _this.switchEditmode(e);
                        } },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { className: this.props.isMe ? __WEBPACK_IMPORTED_MODULE_3__OnlineList_scss___default.a.noStatus : __WEBPACK_IMPORTED_MODULE_3__OnlineList_scss___default.a.status }, this.props.isMe ? "Click to set status" : "Online")));
    };
    __decorate([
        __WEBPACK_IMPORTED_MODULE_7_mobx__["i" /* observable */],
        __metadata("design:type", String)
    ], Userstatus.prototype, "status", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_7_mobx__["i" /* observable */],
        __metadata("design:type", Boolean)
    ], Userstatus.prototype, "editmode", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_4_autobind_decorator___default.a, __WEBPACK_IMPORTED_MODULE_7_mobx__["c" /* action */],
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], Userstatus.prototype, "onChangeStatus", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_4_autobind_decorator___default.a,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], Userstatus.prototype, "switchEditmode", null);
    Userstatus = __decorate([
        __WEBPACK_IMPORTED_MODULE_6_mobx_react__["c" /* observer */],
        __metadata("design:paramtypes", [Object])
    ], Userstatus);
    return Userstatus;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));


/***/ }),

/***/ 593:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(594);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(35)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./Avatar.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./Avatar.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 594:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(34)(undefined);
// imports


// module
exports.push([module.i, ".avatar--2UQpp {\n  position: relative;\n  border-radius: 50%;\n  border: 2px solid steelblue;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center; }\n\n.avatarOnlineStatus--3XDRh {\n  position: absolute;\n  bottom: -3px;\n  right: -3px; }\n\n.onlineStatus--mi_wA {\n  display: inline-block;\n  background: white;\n  border-radius: 50%;\n  border: 1px solid white; }\n  .onlineStatus--mi_wA.online--17lbe {\n    background-color: #2ecc71; }\n  .onlineStatus--mi_wA.connectionProblem--1CEtI {\n    width: 13px;\n    height: 13px;\n    color: #e64c3b; }\n  .onlineStatus--mi_wA.offline--15Txg {\n    background-color: #e64c3b; }\n", ""]);

// exports
exports.locals = {
	"avatar": "avatar--2UQpp",
	"avatarOnlineStatus": "avatarOnlineStatus--3XDRh",
	"onlineStatus": "onlineStatus--mi_wA",
	"online": "online--17lbe",
	"connectionProblem": "connectionProblem--1CEtI",
	"offline": "offline--15Txg"
};

/***/ }),

/***/ 595:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(596);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(35)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./OnlineList.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./OnlineList.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 596:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(34)(undefined);
// imports


// module
exports.push([module.i, ".description--3258L {\n  display: inline-block; }\n\n.hrUser--blDXH {\n  margin: 0.5px 0px;\n  padding: 0 0 10px; }\n\n.noPadding--1CXim {\n  padding-bottom: 0px; }\n\n.status--1ytZP {\n  font-size: 10px;\n  margin: 0;\n  font-style: normal; }\n\n.projectName--IM7PN {\n  display: block !important;\n  position: sticky;\n  top: 0;\n  z-index: 30; }\n\n.noBorder--2YkfI {\n  -webkit-transition: 0.5s !important;\n  -moz-transition: 0.5s !important;\n  -o-transition: 0.5s !important;\n  transition: 0.5s !important;\n  padding-bottom: 0px;\n  padding-top: 0px;\n  border-right: none !important;\n  border-left: none !important;\n  border-top: none !important;\n  border-bottom: none !important; }\n\n.lessPaddingTop--1l5LP {\n  margin: 0 !important;\n  padding: 0 !important; }\n\n.noStatus--1H59c {\n  font-style: italic;\n  color: #8f8f8f; }\n\n.buttonDown--2CMs4 {\n  transition-duration: 0.2s;\n  cursor: pointer; }\n  .buttonDown--2CMs4.buttonOnRight--1Pj3U {\n    line-height: 17px;\n    padding: 1px 5px;\n    float: right; }\n\n.rotated--1MD_4 {\n  transition-duration: 0.2s;\n  -ms-transform: rotate(-180deg);\n  /* IE 9 */\n  -webkit-transform: rotate(-180deg);\n  /* Chrome, Safari, Opera */\n  transform: rotate(-180deg); }\n\n.not--FROW5 {\n  transition-duration: 0.2s;\n  -ms-transform: rotate(-360deg);\n  /* IE 9 */\n  -webkit-transform: rotate(-360deg);\n  /* Chrome, Safari, Opera */\n  transform: rotate(-360deg); }\n\n.clipboard--1pdDO {\n  line-height: 17px;\n  padding: 1px 5px;\n  cursor: pointer; }\n\n.buttonDown--2CMs4:hover, .clipboard--1pdDO:hover {\n  background: #e6e6e6; }\n\n.buttonDown--2CMs4:active, .clipboard--1pdDO:active {\n  background: #cacaca; }\n\ntbody.userdetails--2Av5i td {\n  padding-right: 10px; }\n\n.noUserOnline--1nmcx {\n  color: rgba(0, 0, 0, 0.253);\n  font-style: italic;\n  font-size: 14px;\n  text-align: center;\n  padding-top: 60px;\n  padding-bottom: 60px; }\n\n.centerAvatar--1z3CB {\n  display: flex;\n  align-items: center;\n  justify-content: center; }\n", ""]);

// exports
exports.locals = {
	"description": "description--3258L",
	"hrUser": "hrUser--blDXH",
	"noPadding": "noPadding--1CXim",
	"status": "status--1ytZP",
	"projectName": "projectName--IM7PN",
	"noBorder": "noBorder--2YkfI",
	"lessPaddingTop": "lessPaddingTop--1l5LP",
	"noStatus": "noStatus--1H59c",
	"buttonDown": "buttonDown--2CMs4",
	"buttonOnRight": "buttonOnRight--1Pj3U",
	"rotated": "rotated--1MD_4",
	"not": "not--FROW5",
	"clipboard": "clipboard--1pdDO",
	"userdetails": "userdetails--2Av5i",
	"noUserOnline": "noUserOnline--1nmcx",
	"centerAvatar": "centerAvatar--1z3CB"
};

/***/ }),

/***/ 597:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StatusPageWidgetLogin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StatusPageWidget_scss__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StatusPageWidget_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__StatusPageWidget_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__StatusPage__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__static_brand_icon200_png__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__static_brand_icon200_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__static_brand_icon200_png__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};






var StatusPageWidgetLogin = /** @class */ (function (_super) {
    __extends(StatusPageWidgetLogin, _super);
    function StatusPageWidgetLogin(props) {
        return _super.call(this, props) || this;
    }
    StatusPageWidgetLogin.prototype.validateColor = function () {
        switch (this.props.statusPageStore.status.status.indicator) {
            case "none":
                return this.props.statusPageStore.status.incidents.length > 0 ? "danger" : "info"; //check if there are incidents.
            case "minor": return "warning";
            default: return "danger";
        }
    };
    StatusPageWidgetLogin.prototype.render = function () {
        try {
            var status_1 = this.props.statusPageStore.status;
            var incidents = __WEBPACK_IMPORTED_MODULE_4__StatusPage__["b" /* StatusPageMessageGenerator */].getIncidents(status_1, 11, true);
            var maintance = __WEBPACK_IMPORTED_MODULE_4__StatusPage__["b" /* StatusPageMessageGenerator */].getMaintence(status_1, 11, true);
            return ((this.props.statusPageStore.status.scheduled_maintenances.length > 0
                || (this.props.statusPageStore.status.incidents.length > 0 || this.props.statusPageStore.status.status.indicator !== "none")) &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["a" /* Alert */], { bsStyle: "" + this.validateColor(), style: { paddingBottom: "5px" } },
                    incidents,
                    ((status_1.scheduled_maintenances.length > 0) && (status_1.incidents.length > 0)) && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("hr", { className: __WEBPACK_IMPORTED_MODULE_2__StatusPageWidget_scss___default.a.hrStatus }),
                    maintance,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("hr", { className: __WEBPACK_IMPORTED_MODULE_2__StatusPageWidget_scss___default.a.hrStatus }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { style: { fontSize: 10 }, target: "_blank", href: "http://status.fleetplan.net/" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: __WEBPACK_IMPORTED_MODULE_5__static_brand_icon200_png___default.a, style: { height: "12px", width: "12px", paddingBottom: "2px" } }),
                        " ",
                        "statuspage.io"),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "pull-right", style: { fontSize: 10, color: "grey", fontStyle: "italic" } },
                        "Last refresh:",
                        " ",
                        this.props.statusPageStore.date.getHours(),
                        ":",
                        this.props.statusPageStore.date.getMinutes() < 10 ? "0" + this.props.statusPageStore.date.getMinutes() : this.props.statusPageStore.date.getMinutes())));
        }
        catch (err) {
            if (err = "TypeError") {
                return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["a" /* Alert */], { bsStyle: "danger" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__StatusPage__["a" /* StatusPageError */], { fontSize: 10 }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("hr", { className: __WEBPACK_IMPORTED_MODULE_2__StatusPageWidget_scss___default.a.hrStatus }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { style: { fontSize: 10 }, target: "_blank", href: "http://status.fleetplan.net/" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: __WEBPACK_IMPORTED_MODULE_5__static_brand_icon200_png___default.a, style: { height: "12px", width: "12px", paddingBottom: "2px" } }),
                        " ",
                        "statuspage.io"),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "pull-right", style: { fontSize: 10, color: "grey",
                            fontStyle: "italic" } },
                        "Last update:",
                        " ",
                        this.props.statusPageStore.date.getHours(),
                        ":",
                        this.props.statusPageStore.date.getMinutes() < 10 ? "0" + this.props.statusPageStore.date.getMinutes() : this.props.statusPageStore.date.getMinutes())));
            }
            else {
                alert(this.props.statusPageStore + " " + err);
            }
        }
    };
    StatusPageWidgetLogin = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["b" /* inject */])("statusPageStore"),
        __WEBPACK_IMPORTED_MODULE_3_mobx_react__["c" /* observer */],
        __metadata("design:paramtypes", [Object])
    ], StatusPageWidgetLogin);
    return StatusPageWidgetLogin;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));



/***/ }),

/***/ 598:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Table; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TableCell; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_autobind_decorator__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_autobind_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_autobind_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Table_scss__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Table_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Table_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mobx_react__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};






var Table = /** @class */ (function (_super) {
    __extends(Table, _super);
    function Table() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderCache = new Map();
        _this.offsetCache = new Map();
        _this.hiddenCells = new Set();
        _this.scrolled = false;
        _this.lastScrollCalc = +new Date();
        _this.activeArea = { x0: 0, y0: 0, x1: 0, y1: 0 };
        return _this;
    }
    Object.defineProperty(Table.prototype, "virtualized", {
        get: function () {
            var totalsCells = this.props.columns * this.props.rows;
            return totalsCells > Infinity; // 7500;
            // TODO: needs fix for visible area calculation first
        },
        enumerable: true,
        configurable: true
    });
    Table.prototype.componentDidMount = function () {
        var _this = this;
        // setup reaction to change of virtualized state
        Object(__WEBPACK_IMPORTED_MODULE_3_mobx__["j" /* reaction */])(function () { return _this.virtualized; }, function () {
            if (_this.virtualized) {
                // we need to start the requestAnimationFrame loop if virtualization becomes active
                requestAnimationFrame(_this.onFrame);
            }
            else {
                // everything is active if we aren't virtualized
                _this.activeArea = {
                    x0: 0,
                    y0: 0,
                    x1: Infinity,
                    y1: Infinity,
                };
            }
        }, { fireImmediately: true });
    };
    /**
     * Runs on each frame if `this.virtualized === true`.
     * Updates `activeArea` which in turn triggers a `render()`
     */
    Table.prototype.onFrame = function () {
        // exit the loop if we aren't virtualized
        if (!this.virtualized) {
            return;
        }
        var timeSinceLast = +new Date() - this.lastScrollCalc;
        if (timeSinceLast > 100 && this.scrolled) {
            this.scrolled = false;
            this.lastScrollCalc = +new Date();
            // TODO: sizing
            this.activeArea.x0 = Math.floor(this.container.scrollLeft / 100);
            this.activeArea.y0 = Math.floor(this.container.scrollTop / 20);
            this.activeArea.x1 = Math.ceil((this.container.scrollLeft + this.container.clientWidth) / 100);
            this.activeArea.y1 = Math.ceil((this.container.scrollTop + this.container.clientHeight) / 20) + 30;
        }
        requestAnimationFrame(this.onFrame);
    };
    /**
     * Calculates the intersection (overlap) of two Areas
     * @param a1 first Area
     * @param a2 second Area
     * @returns intersection of Area
     */
    Table.prototype.areaIntersection = function (a1, a2) {
        return {
            x0: Math.max(a1.x0, a2.x0), y0: Math.max(a1.y0, a2.y0),
            x1: Math.min(a1.x1, a2.x1), y1: Math.min(a1.y1, a2.y1),
        };
    };
    Table.prototype.render = function () {
        var _this = this;
        var topLeft = this.getCells({
            x0: 0,
            y0: 0,
            x1: this.props.fixedLeft,
            y1: this.props.fixedTop,
        });
        var top = this.getCells(this.areaIntersection({
            x0: this.activeArea.x0 + this.props.fixedLeft,
            y0: 0,
            x1: this.activeArea.x1,
            y1: this.props.fixedTop,
        }, {
            x0: this.props.fixedLeft,
            y0: 0,
            x1: this.props.columns,
            y1: this.props.fixedTop,
        }));
        var left = this.getCells(this.areaIntersection({
            x0: 0,
            y0: this.activeArea.y0 + this.props.fixedTop,
            x1: this.props.fixedLeft,
            y1: this.activeArea.y1,
        }, {
            x0: 0,
            y0: this.props.fixedTop,
            x1: this.props.fixedLeft,
            y1: this.props.rows,
        }));
        var content = this.getCells(this.areaIntersection({
            x0: this.activeArea.x0 + this.props.fixedLeft,
            y0: this.activeArea.y0 + this.props.fixedTop,
            x1: this.activeArea.x1,
            y1: this.activeArea.y1,
        }, {
            x0: this.props.fixedLeft,
            y0: this.props.fixedTop,
            x1: this.props.columns,
            y1: this.props.rows,
        }));
        var tableStyles = "";
        for (var i in this.props.tableStyles) {
            var s = this.props.tableStyles[i];
            if (__WEBPACK_IMPORTED_MODULE_2__Table_scss___default.a.hasOwnProperty(s)) {
                tableStyles += __WEBPACK_IMPORTED_MODULE_2__Table_scss___default.a[s] + " ";
            }
            else {
                throw ReferenceError("'." + s + "' is not available as table style class");
            }
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_2__Table_scss___default.a.container + " " + (tableStyles.length ? tableStyles : __WEBPACK_IMPORTED_MODULE_2__Table_scss___default.a.defaultStyle), ref: function (r) { return _this.container = r; }, onScroll: function (e) { return _this.scrolled = true; }, style: { width: "100%", height: "100%" } },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_2__Table_scss___default.a.topLeft }, topLeft),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_2__Table_scss___default.a.top }, top),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_2__Table_scss___default.a.left }, left),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_2__Table_scss___default.a.content, style: {
                    width: this.calculateOffset("x", this.props.columns) + "px",
                    height: this.calculateOffset("y", this.props.rows) + "px"
                } }, content)));
    };
    /**
     * returns all cells in the given area
     * @param area requested area
     */
    Table.prototype.getCells = function (area) {
        var cells = [];
        for (var y = area.y0; y < area.y1; y++) {
            for (var x = area.x0; x < area.x1; x++) {
                var cell = this.renderCell({ y: y, x: x });
                if (cell) {
                    cells.push(cell);
                }
            }
        }
        return cells;
    };
    Table.prototype.renderCell = function (pos) {
        var key = pos.x + "y" + pos.y;
        if (this.renderCache.has(key)) {
            return this.renderCache.get(key);
        }
        if (this.hiddenCells.has(key)) {
            return;
        }
        var cell;
        var props = {
            table: this,
            pos: pos,
        };
        try {
            cell = this.props.renderCell(pos, props);
        }
        catch (e) {
            cell = __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](TableCell, __assign({}, props),
                e.toString(),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("pre", null, JSON.stringify(e)));
        }
        if (cell.props.colSpan > 1 || cell.props.rowSpan > 1) {
            // hidden area is 1 too big, that is handled by the loop
            var hiddenArea = {
                x0: pos.x,
                y0: pos.y,
                x1: pos.x + (cell.props.colSpan || 1),
                y1: pos.y + (cell.props.rowSpan || 1),
            };
            for (var x = hiddenArea.x0; x < hiddenArea.x1; x++) {
                for (var y = hiddenArea.y0; y < hiddenArea.y1; y++) {
                    var hiddenKey = x + "y" + y;
                    // don't hide ourself
                    if (key !== hiddenKey) {
                        this.hiddenCells.add(hiddenKey);
                    }
                }
            }
        }
        this.renderCache.set(key, cell);
        return cell;
    };
    Table.prototype.calculateOffset = function (dir, index) {
        var key = dir + "," + index;
        if (this.offsetCache.has(key)) {
            return this.offsetCache.get(key);
        }
        if (index === 0) {
            return 0;
        }
        var offset = this.calculateOffset(dir, index - 1);
        if (dir === "x") {
            offset += this.props.getColumnWidth(index - 1);
        }
        else if (dir === "y") {
            offset += this.props.getRowHeight(index - 1);
        }
        this.offsetCache.set(key, offset);
        return offset;
    };
    Table.prototype.calculateCellOffset = function (pos) {
        return {
            x: this.calculateOffset("x", pos.x),
            y: this.calculateOffset("y", pos.y),
        };
    };
    __decorate([
        __WEBPACK_IMPORTED_MODULE_3_mobx__["i" /* observable */],
        __metadata("design:type", Object)
    ], Table.prototype, "activeArea", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_3_mobx__["d" /* computed */],
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], Table.prototype, "virtualized", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_autobind_decorator___default.a,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], Table.prototype, "onFrame", null);
    Table = __decorate([
        __WEBPACK_IMPORTED_MODULE_4_mobx_react__["c" /* observer */]
    ], Table);
    return Table;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));

var TableCell = /** @class */ (function (_super) {
    __extends(TableCell, _super);
    function TableCell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableCell.prototype.render = function () {
        // grab props
        var _a = this.props, table = _a.table, pos = _a.pos, children = _a.children;
        var rowSpan = this.props.rowSpan || 1;
        var colSpan = this.props.colSpan || 1;
        // calculate some stuff
        var offset = table.calculateCellOffset(pos);
        var height = 0;
        for (var i = 0; i < rowSpan; i++) {
            height += table.props.getRowHeight(pos.y + i);
        }
        var width = 0;
        for (var i = 0; i < colSpan; i++) {
            width += table.props.getColumnWidth(pos.x + i);
        }
        // build style
        var style = Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["assign"])({
            position: "absolute",
            top: offset.y + "px",
            left: offset.x + "px",
            height: height + "px",
            width: width + "px",
            overflow: "hidden",
            lineHeight: "25px"
        }, this.props.style); // merge with props
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { key: pos.x + "," + pos.y, style: style, className: __WEBPACK_IMPORTED_MODULE_2__Table_scss___default.a.cell + " " + this.props.className }, children);
    };
    TableCell = __decorate([
        __WEBPACK_IMPORTED_MODULE_4_mobx_react__["c" /* observer */]
    ], TableCell);
    return TableCell;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));



/***/ }),

/***/ 599:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(600);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(35)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./Table.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./Table.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 600:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(34)(undefined);
// imports


// module
exports.push([module.i, ".container--38G8D {\n  transform: translate3d(0, 0, 0);\n  position: relative;\n  overflow: auto;\n  border-top: 1px solid #dddddd;\n  font-size: 11.7px; }\n\n.topLeft--3LM0O {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 0;\n  left: 0;\n  z-index: 3; }\n\n.top--k1zPf {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 0;\n  z-index: 2; }\n\n.left--2cArU {\n  position: -webkit-sticky;\n  position: sticky;\n  left: 0;\n  z-index: 1; }\n\n.content--1cIlN {\n  position: absolute;\n  top: 0;\n  left: 0; }\n\n.cell--14L4U.bg-success {\n  background-color: #dff0d8; }\n\n.cell--14L4U.bg-danger {\n  background-color: #f2dede; }\n\n.cell--14L4U.bg-warning {\n  background-color: #fcf8e3; }\n\n.cell--14L4U.bg-primary {\n  background-color: #337ab7; }\n\n.defaultStyle--2wjh6 {\n  background: white; }\n  .defaultStyle--2wjh6 .cell--14L4U {\n    padding: 3px 5px;\n    border-bottom: 1px solid #dddddd;\n    border-right: 1px solid #dddddd;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    background-color: white; }\n\n.striped--2AXZB .cell--14L4U {\n  border-right: 1px solid #dddddd;\n  text-overflow: ellipsis;\n  text-overflow: ellipsis;\n  white-space: nowrap; }\n\n.striped--2AXZB .cell--14L4U:nth-child(even) {\n  background-color: white; }\n\n.striped--2AXZB .cell--14L4U:nth-child(even) {\n  background-color: #f9f9f9; }\n", ""]);

// exports
exports.locals = {
	"container": "container--38G8D",
	"topLeft": "topLeft--3LM0O",
	"top": "top--k1zPf",
	"left": "left--2cArU",
	"content": "content--1cIlN",
	"cell": "cell--14L4U",
	"defaultStyle": "defaultStyle--2wjh6",
	"striped": "striped--2AXZB"
};

/***/ }),

/***/ 601:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FpProvider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_index__ = __webpack_require__(56);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};



var FpProvider = /** @class */ (function (_super) {
    __extends(FpProvider, _super);
    function FpProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FpProvider.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_mobx_react__["a" /* Provider */], __assign({}, __WEBPACK_IMPORTED_MODULE_2__lib_index__["b" /* LIB_INSTANCES */]), this.props.children);
    };
    return FpProvider;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));



/***/ }),

/***/ 603:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./authority/index": [
		604,
		3
	],
	"./calendar/index": [
		605,
		1
	],
	"./certsdocs/index": [
		606,
		2
	],
	"./import/index": [
		607,
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 603;
module.exports = webpackAsyncContext;

/***/ })

},[355]);


// WEBPACK FOOTER //
// app.2e873a6944ebd4fa5e39.bundle.js